import React, { useEffect,useState,useRef } from 'react'
import HeaderofAdash from '../../subComponent/HeaderofAdash'
import SidebarOfAdash from '../../subComponent/SidebarOfAdash'
import { adminHeaderApi } from '../../../../utils/AdminDashApi/HeaderApi'
import { BiBell } from 'react-icons/bi'
import {Row,Col,Modal,Tab,Nav} from 'react-bootstrap'
import '../../../../sassFiles/sassPages/admindashboard/bill/billlallstyle.scss'
import '../../../../sassFiles/sassPages/admindashboard/studentEntryMainPage.scss'
import { billCollectionApi, prevCollectionhistoryApi, searchtableApi } from '../../../../utils/AdminDashApi/Bill/BillApi'
import { optionsCampus, optionsCountry, optionsDistrict, optionsDivision, optionsShift, optionsStatusAI, optionsThana, optionsapplicationstatus, optionsbilltype, optionsbloodgroup, optionsgender, optionsmarkallow, optionsnationality, optionsreligion, optionssection } from '../../../Helper'
import Dropdown2 from '../../../subComponents/CustomSubComponents/Dropdown2'
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { HighlightRowText } from '../../../../pages/adminDashboard/Bill/subComponents/HighlightRowText'
import { statusTableApi } from '../../../../utils/DashboardApi/AdminDashboard/StatusTableApi'
import { paymenthistorystuApi } from '../../../../utils/DashboardApi/AdminDashboard/paymenthistorystuApi'
import { tr } from 'date-fns/locale'
import Purplebutton from '../subComponent/Purplebutton'
const StudentEntryMainComp = () => {

    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Methods": "*",
    }

    const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const [stuimgvar,setstuimgvar] = useState("")

  const handleFileChange = (imgfile) => {
   
    console.log('Selected file:', imgfile[0]);
    
                    let reader = new FileReader();
                    reader.onload = () => {
                      var myfile1 = reader.result;
                     
                      console.log(myfile1);
                      setstuimgvar(myfile1);
                    };
                    reader.readAsDataURL(imgfile[0]);
                    console.log(stuimgvar);
  };

    const [searchkey,setsearchkey] = useState("")
    const [screenSize, getDimension] = useState({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
      });
      const setDimension = () => {
        getDimension({
          dynamicWidth: window.innerWidth,
          dynamicHeight: window.innerHeight
        })
      }
      useEffect(() => {
        const fetchSessionDropdown = async () => {
            try {
                const sessionresponse = await axios.get(
                    "https://localhost:7229/api/Public/SessionDropDown",
                    {},
                    headers
                );
                setsessionrsponse(sessionresponse.data);
            } catch (err) {
                if (err.sessionresponse) {
                    console.error(err.sessionresponse.data);
                    console.log(err.sessionresponse.status);
                    console.log(err.sessionresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchSessionDropdown();
    }, []);
      useEffect(() => {
        window.addEventListener('resize', setDimension);

        return(() => {
            window.removeEventListener('resize', setDimension);

        })
      }, [screenSize])

      const handleInputSearch = (e)=>{
        setsearchkey(e.target.value)
    }
      const [searchpopulatedata,setsearchpopulatedata] = useState({
        headerid:"",
        id:""
    })
    const [studentHeaderId, setstudentHeaderId] = useState("");
    //const [id, setid] = useState("");
    const [name, setname] = useState("");
    const [className, setclassName] = useState("");
    const [section, setsection] = useState("");
    const [status, setstatus] = useState("");
    const [stuSearchInforesponse, setstuSearchInforesponse] = useState([]);

    const [id,setid] = useState("")
    const [proxnum,setproxnum] = useState("")
    const [classcurrent,setclasscurrent] = useState("")

    const [semail, setsemail] = useState("")
    const [smobile, setsmobile] = useState("")
    const [smobileres, setsmobileres] = useState("")
    const [resession,setresession] = useState("")
    const [headerid,setheaderid]= useState("")
    const [sfirstname,setsfirstname] = useState("")
    const [smiddlename,setsmiddlename] = useState("")
    const [ffirstname,setffirstname] = useState("")
    const [fmiddlename,setfmiddlename] = useState("")
    const [flastname,setflastname] = useState("")
    const [lglastname,setlglastname] = useState("")
    const [lgfirstname,setlgfirstname] = useState("")
    const [lgmiddlename,setlgmiddlename] = useState("")
    const [mfirstname,setmfirstname] = useState("")
    const [mmiddlename,setmmiddlename] = useState("")
    const [mlastname,setmlastname] = useState("")
    const [slastname,setslastname] = useState("")
    const [nickname,setnickname] = useState("")
    const [gender,setgender] = useState("")
    const [dateofadmission, setdateofadmission] = useState("")
    const [classoptions, setclassoptions] = useState("")
    const [sectionoptions, setsectionoptions] = useState("")
    const [shiftoptions, setshiftoptions] = useState("")
    const [shiftcurrent,setshiftcurrent] = useState("")
    const [drpsesstionselect, setdrpsession] = useState("")
    const [sessioncurrent,setsessioncurrent] = useState("")
    const [statusoptions, setstatusoptions] = useState("Active")
    const [campusoptions, setcampusoptions] = useState("")
    const [dateofbirthstu, setdateofbirthstu] = useState("")
    const [sremarks, setsremarks] = useState("")
    const [presentadholding,setpresentadholding] = useState("")
    const [presentadroad,setpresentadroad] = useState("")
    const [presentadarea,setpresentadarea] = useState("")
    const [presentpostcode,setpresentpostcode] = useState("")
    const [presentcountry,setpresentcountry] = useState("")
    const [presentdivision,setpresentdivision] = useState("")
    const [presentdistrict,setpresentdistrict] = useState("")
    const [presentthana,setpresentthana] = useState("")
    const [permanentadholding,setpermanentadholding] = useState("")
    const [permanentadroad,setpermanentadroad] = useState("")
    const [permanentadarea,setpermanentadarea] = useState("")
    const [permanentpostcode,setpermanentpostcode] = useState("")
    const [permanentcountry,setpermanentcountry] = useState("")
    const [permanentdivision,setpermanentdivision] = useState("")
    const [permanentdistrict,setpermanentdistrict] = useState("")
    const [permanentthana,setpermanentthana] = useState("")




    const [borderproxnum,setborderproxnum] = useState(false)
    const [borderflastname,setborderflastname] = useState(false)
    const [borderfmiddlename,setborderfmiddlename] = useState(false)
    const [borderffirstname,setborderffirstname] = useState(false)
    const [borderlglastname,setborderlglastname] = useState(false)
    const [borderlgmiddlename,setborderlgmiddlename] = useState(false)
    const [borderlgfirstname,setborderlgfirstname] = useState(false)
    const [bordermlastname,setbordermlastname] = useState(false)
    const [bordermmiddlename,setbordermmiddlename] = useState(false)
    const [bordermfirstname,setbordermfirstname] = useState(false)
    const [borderpresentpostcode,setborderpresentpostcode] = useState(false)
    const [borderpresentthana,setborderpresentthana] = useState(false)
    const [borderpresentdistrict,setborderpresentdistrict] = useState(false)
    const [borderpresentdivision,setborderpresentdivision] = useState(false)
    const [borderpresentcountry,setborderpresentcountry] = useState("")
    const [borderpresentarea,setborderpresentarea] = useState(false)
    const [borderpresentroad,setborderpresentroad] = useState(false)
    const [borderpresentadholding,setborderpresentadholding] = useState(false)
    const [borderpermanentpostcode,setborderpermanentpostcode] = useState(false)
    const [borderpermanentthana,setborderpermanentthana] = useState(false)
    const [borderpermanentdistrict,setborderpermanentdistrict] = useState(false)
    const [borderpermanentdivision,setborderpermanentdivision] = useState(false)
    const [borderpermanentcountry,setborderpermanentcountry] = useState(false)
    const [borderpermanentarea,setborderpermanentarea] = useState(false)
    const [borderpermanentroad,setborderpermanentroad] = useState(false)
    const [borderpermanentadholding,setborderpermanentadholding] = useState(false)
    const [borderresession,setborderresession] = useState(false)
    const [bordersessioncurrent,setbordersessioncurrent] = useState(false)
    const [bordernickname,setbordernickname] = useState("")
    const [bordersmoblie,setbordersmobile] = useState(false)
    const [bordersmoblieres,setbordersmobileres] = useState(false)
    const [borderid,setborderid] = useState("")
    const [borderheaderid,setborderheaderid] = useState("")
    const [bordersfirstname, setbordersfirstname] = useState(false)
    const [bordersmiddlename, setbordersmiddlename] = useState(false)
    const [bordergender, setbordergender] = useState(false)
    const [borderdateofadmission,setborderdateofadmission] = useState(false)
    const [bordersection, setbordersection] = useState("")
    const [bordersectioncurrent, setbordersectioncurrent] = useState("")
    const [bordersession, setbordersession] = useState("")
    const [bordershift, setbordershift] = useState("")
    const [bordershiftcurrent, setbordershiftcurrent] = useState("")
    const [borderclass, setborderclass] = useState("")
    const [borderclasscurrent, setborderclasscurrent] = useState("")
    const [bordercampus, setbordercampus] = useState("")
    const [borderstatus, setborderstatus] = useState("")
    const [bordersbirthdt,setbordersbirthdt] = useState(false)
    const [bordersemail,setbordersemail] = useState(false)
    const [borderleavedt,setborderleavedt] = useState(false)
    const [borderremarks,setborderremarks] = useState(false)

    const [labelproxnum,setlabelproxnum] = useState("")
    const [labelid,setlabelid] = useState("")
    const [labelsmobile, setlabelsmobile] = useState("")
    const [labelsmobileres, setlabelsmobileres] = useState("")
    const [labelsemail, setlabelsemail] = useState("")
    const [labelheaderid,setlabelheaderid] = useState("")
    const [labelsfirstname, setlabelsfirstname] = useState("")
    const [labelsmiddlename, setlabelsmiddlename] = useState("")
    const [labelslastname, setlabelslastname] = useState("")
    const [labelnickname, setlabelnickname] = useState("")
    const [labelgender, setlabelgender] = useState("")
    const [labelsession, setlabelsession] = useState("")
    const [labelsessioncurrent, setlabelsessioncurrent] = useState("")
    const [labelsection, setlabelsection] = useState("")
    const [labelsectioncurrent, setlabelsectioncurrent] = useState("")
    const [labeladmissiondate, setlabeladmissiondate] = useState("")
    const [labelclass, setlabelclass] = useState("")
    const [labelclasscurrent, setlabelclasscurrent] = useState("")
    const [labelshift, setlabelshift] = useState("")
    const [labelshiftcurrent, setlabelshiftcurrent] = useState("")
    const [labelcampus, setlabelcampus] = useState("")
    const [labelstatus, setlabelstatus] = useState("")
    const [isReadmission,setIsReadmission]= useState("")
    const [labeldateofbirthstu, setlabeldateofbirthstu] = useState("")
    const [labeldateofleavestu, setlabeldateofleavestu] = useState("")
    const [labelsremarks, setlabelsremarks] = useState("")
    const [labelresession, setlabelresession] = useState("")
    const [labelsetpresentadholding, setlabelsetpresentadholding] = useState("")
    const [labelsetpresentroad, setlabelsetpresentroad] = useState("")
    const [labelsetpresentarea, setlabelsetpresentarea] = useState("")
    const [labelpresentcountry, setlabelpresentcountry] = useState("")
    const [labelpresentdivision, setlabelpresentdivision] = useState("")
    const [labelpresentdistrict, setlabelpresentdistrict] = useState("")
    const [labelpresentthana, setlabelpresentthana] = useState("")
    const [labelpresentpostcode, setlabelpresentpostcode] = useState("")
    const [labelsetpermanentadholding, setlabelsetpermanentadholding] = useState("")
    const [labelsetpermanentroad, setlabelsetpermanentroad] = useState("")
    const [labelsetpermanentarea, setlabelsetpermanentarea] = useState("")
    const [labelpermanentcountry, setlabelpermanentcountry] = useState("")
    const [labelpermanentdivision, setlabelpermanentdivision] = useState("")
    const [labelpermanentdistrict, setlabelpermanentdistrict] = useState("")
    const [labelpermanentthana, setlabelpermanentthana] = useState("")
    const [labelpermanentpostcode, setlabelpermanentpostcode] = useState("")
    const [labelffirstname, setlabelffirstname] = useState("")
    const [labelfmiddlename, setlabelfmiddlename] = useState("")
    const [labelflastname, setlabelflastname] = useState("")
    const [labelmfirstname, setlabelmfirstname] = useState("")
    const [labelmmiddlename, setlabelmmiddlename] = useState("")
    const [labelmlastname, setlabelmlastname] = useState("")
    const [labellgfirstname, setlabellgfirstname] = useState("")
    const [labellgmiddlename, setlabellgmiddlename] = useState("")
    const [labellglastname, setlabellglastname] = useState("")


    const [genderid,setgenderid] = useState("")
    const [admsessionid,setadmsessionid] = useState("")
    const [admclassid,setadmclassid] = useState("")
    const [admsectionid,setadmsectionid] = useState("")
    const [admshiftid,setadmshiftid] = useState("")
    const [currentsessionid,setcurrentsessionid] = useState("")
    const [currentclassid,setcurrentclassid] = useState("")
    const [currentsectionid,setcurrentsectionid] = useState("")
    const [currentshiftid,setcurrentshiftid] = useState("")
    const [currentcampusid,setcurrentcampusid] = useState("")
    const [statusid,setstatusid] = useState("")
    const [religionid,setreligionid] = useState("")
    const [bloodgroupid,setbloodgroupid] = useState("")
    const [nationalityid,setnationalityid] = useState("")
    const [permthanaid,setpermthanaid] = useState("")
    const [permcityid,setpermcityid] = useState("")
    const [permdivisionid,setpermdivisionid] = useState("")
    const [permcountryid,setpermcountryid] = useState("")
    const [presthanaid,setpresthanaid] = useState("")
    const [prescityid,setprescityid] = useState("")
    const [presdivisionid,setpresdivisionid] = useState("")
    const [prescountryid,setprescountryid] = useState("")
    const [applicationstatusid,setapplicationstatusid] = useState("")
    const [allowmarkid,setallowmarkid] = useState("")
    const [allowSecondSemid,setallowSecondSemid] = useState("")
    const [allowSecondSemidforapi,setallowSecondSemidforapi] = useState("")


    const [leavedate,setleavedate] = useState(null)

    const [isSameaddress,setisSameaddress] = useState("")

    async function SearchStudentInfo(SearchKeyWord) {
        try {
            
          axios.get(`https://localhost:7229/api/StudentEntry/GetStudentsInfoBySearch?searchText=${SearchKeyWord}`, headers)
          .then(function (response) {
            setstuSearchInforesponse(response.data);
          });
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
          } else {
            console.error(`Error: ${err.message}`);
          }
        }
      }
      const handleSearchButton= async ()=>{
        handleClearBtn();
        console.log(isReadmission);
        await SearchStudentInfo(searchkey);
      }
      const [stuInforesponse, setstuInforesponse] = useState([]);
      const [stuPrvsBillresponse, setstuPrvsBillresponse] = useState([]);



      async function GetStudentsInfoBySelectedSearchValue(HId) {
        try {
          axios.get(`https://localhost:7229/api/StudentEntry/GetStudentInfoBySearchValue?studentHeaderId=${HId}`, headers)
          .then(function (response) {
            if (response.status == 200){
               

                    setstuInforesponse(response.data);
                    setsearchkey("")
                    setid(response.data.studenT_ID?response.data.studenT_ID:"")
                    setheaderid(response.data.studenT_HEADER_ID?response.data.studenT_HEADER_ID:"")
                    setsfirstname(response.data.firsT_NAME?response.data.firsT_NAME:"")
                    setsmiddlename(response.data.middlE_NAME?response.data.middlE_NAME:"")
                    setslastname(response.data.lasT_NAME?response.data.lasT_NAME:"")
                    setnickname(response.data.nicK_NAME?response.data.nicK_NAME:"")
                    setpresentadholding(response.data.preS_HOLDING_NO?response.data.preS_HOLDING_NO:"")
                    setpresentadroad(response.data.preS_STREET?response.data.preS_STREET:"")
                    setpresentadarea(response.data.preS_AREA?response.data.preS_AREA:"")
                    setpresthanaid(response.data.preS_THANA_ID?response.data.preS_THANA_ID:"")
                    setpresentpostcode(response.data.preS_POST_CODE?response.data.preS_POST_CODE:"")
                    setprescityid(response.data.preS_CITY_ID?response.data.preS_CITY_ID:"")
                    setpresdivisionid(response.data.preS_DIVISION_ID?response.data.preS_DIVISION_ID:"")
                    setprescountryid(response.data.preS_COUNTRY_ID?response.data.preS_COUNTRY_ID:"")
                    setpermanentadholding(response.data.perM_HOLDING_NO?response.data.perM_HOLDING_NO:"")
                    setpermanentadroad(response.data.perM_STREET?response.data.perM_STREET:"")
                    setpermanentadarea(response.data.perM_AREA?response.data.perM_AREA:"")
                    setpermanentpostcode(response.data.perM_POST_CODE?response.data.perM_POST_CODE:"")
                    setpermthanaid(response.data.perM_THANA_ID?response.data.perM_THANA_ID:"")
                    
                    setpermcityid(response.data.perM_CITY_ID?response.data.perM_CITY_ID:"")
                    setpermdivisionid(response.data.perM_DIVISION_ID?response.data.perM_DIVISION_ID:"")
                    setpermcountryid(response.data.perM_COUNTRY_ID?response.data.perM_COUNTRY_ID:"")
                    setdateofbirthstu(response.data.dob?response.data.dob:"")
                    // setid(response.data.birtH_CITY?response.data.birtH_CITY:"")
                    // setid(response.data.birtH_COUNTRY?response.data.birtH_COUNTRY:"")
                    // setid(response.data.placE_OF_BIRTH?response.data.placE_OF_BIRTH:"")
                    setdateofadmission(response.data.admissioN_DATE?response.data.admissioN_DATE:"")
    
                    setadmsessionid(response.data.admissioN_SESSION_ID?response.data.admissioN_SESSION_ID:"")
                    setadmclassid(response.data.admissioN_CLASS_ID?response.data.admissioN_CLASS_ID:"")
                    setadmsectionid(response.data.admissioN_SECTION_ID?response.data.admissioN_SECTION_ID:"")
                    setadmshiftid(response.data.admissioN_SHIFT?response.data.admissioN_SHIFT:"")
                    setcurrentsessionid(response.data.sessioN_ID?response.data.sessioN_ID:"")
                    setcurrentclassid(response.data.clasS_ID?response.data.clasS_ID:"")
                    setcurrentsectionid(response.data.sectioN_ID?response.data.sectioN_ID:"")
                    setcurrentshiftid(response.data.shift?response.data.shift:"")
                    setcurrentcampusid(response.data.campuS_ID?response.data.campuS_ID:"")
                    setleavedate(response.data.enD_DATE?response.data.enD_DATE:"")
                    setstatusid(response.data.status)
                    setgenderid(response.data.gender?response.data.gender:"")
                    setreligionid(response.data.religion?response.data.religion:"")
                    setsmobileres(response.data.reS_PHONE?response.data.reS_PHONE:"")
                    setsmobile(response.data.mobile?response.data.mobile:"")
                    setsemail(response.data.email?response.data.email:"")
                    setbloodgroupid(response.data.blooD_GROUP?response.data.blooD_GROUP:"")
                    setnationalityid(response.data.nationality?response.data.nationality:"")
                    setstubirthcertificate(response.data.birtH_CERTIFICATE_NO?response.data.birtH_CERTIFICATE_NO:"")
                    setstupassport(response.data.passporT_NO?response.data.passporT_NO:"")
                    setstumedicalhistory(response.data.medicaL_HISTORY?response.data.medicaL_HISTORY:"")
                    setstuemergencymedical(response.data.emergencY_MEDICAL_ACTION?response.data.emergencY_MEDICAL_ACTION:"")
                    setffirstname(response.data.fatheR_FIRST_NAME?response.data.fatheR_FIRST_NAME:"")
                    setfmiddlename(response.data.fatheR_MIDDLE_NAME?response.data.fatheR_MIDDLE_NAME:"")
                    setflastname(response.data.fatheR_LAST_NAME?response.data.fatheR_LAST_NAME:"")
                    setfeducation(response.data.fatheR_EDUCATION?response.data.fatheR_EDUCATION:"")
                    setfedudetails(response.data.fatheR_EDUCATION_DETAILS?response.data.fatheR_EDUCATION_DETAILS:"")
                    setfoccupation(response.data.fatheR_OCCUPATION?response.data.fatheR_OCCUPATION:"")
                    setfoccudetails(response.data.fatheR_OCCUPATION_DETAILS?response.data.fatheR_OCCUPATION_DETAILS:"")
                    setfofficeaddress(response.data.fatheR_OFFICE_ADDRESS?response.data.fatheR_OFFICE_ADDRESS:"")
                    setfphone(response.data.fatheR_OFFICE_PHONE?response.data.fatheR_OFFICE_PHONE:"")
                    setfmobile(response.data.fatheR_MOBILE?response.data.fatheR_MOBILE:"")
                    setfnationalid(response.data.fatheR_NATIONAL_ID?response.data.fatheR_NATIONAL_ID:"")
                    setfpassport(response.data.fatheR_PASSPORT_NO?response.data.fatheR_PASSPORT_NO:"")
                    setmfirstname(response.data.motheR_FIRST_NAME?response.data.motheR_FIRST_NAME:"")
                    setmmiddlename(response.data.motheR_MIDDLE_NAME?response.data.motheR_MIDDLE_NAME:"")
                    setmlastname(response.data.motheR_LAST_NAME?response.data.motheR_LAST_NAME:"")
                    setmeducation(response.data.motheR_EDUCATION?response.data.motheR_EDUCATION:"")
                    setmedudetails(response.data.motheR_EDUCATION_DETAILS?response.data.motheR_EDUCATION_DETAILS:"")
                    setmoccupation(response.data.motheR_OCCUPATION?response.data.motheR_OCCUPATION:"")
                    setmoccudetails(response.data.motheR_OCCUPATION_DETAILS?response.data.motheR_OCCUPATION_DETAILS:"")
                    setmofficeaddress(response.data.motheR_OFFICE_ADDRESS?response.data.motheR_OFFICE_ADDRESS:"")
                    setmphone(response.data.motheR_OFFICE_PHONE?response.data.motheR_OFFICE_PHONE:"")
                    setmmobile(response.data.motheR_MOBILE?response.data.motheR_MOBILE:"")
                    setmnationalid(response.data.motheR_NATIONAL_ID?response.data.motheR_NATIONAL_ID:"")
                    setmpassport(response.data.moheR_PASSPORT_NO?response.data.moheR_PASSPORT_NO:"")
                    setlgfirstname(response.data.loC_GUARDIAN_FIRST_NAME?response.data.loC_GUARDIAN_FIRST_NAME:"")
                    setlgmiddlename(response.data.loC_GUARDIAN_MIDDLE_NAME?response.data.loC_GUARDIAN_MIDDLE_NAME:"")
                    setlglastname(response.data.loC_GUARDIAN_LAST_NAME?response.data.loC_GUARDIAN_LAST_NAME:"")
                    // setid(response.data.loC_GUARDIAN_RELATIONSHIP?response.data.loC_GUARDIAN_RELATIONSHIP:"")
                    setlgmobile(response.data.loC_GUARDIAN_MOBILE?response.data.loC_GUARDIAN_MOBILE:"")
                    setlgnationalid(response.data.locaL_GURDIAN_NATIONAL_ID?response.data.locaL_GURDIAN_NATIONAL_ID:"")
                    setlgpassport(response.data.locaL_GURDIAN_PASSPORT_NO?response.data.locaL_GURDIAN_PASSPORT_NO:"")
                    // setid(response.data.studenT_PHOTO_PATH?response.data.studenT_PHOTO_PATH:"")
                    setproxnum(response.data.proximitY_NUM?response.data.proximitY_NUM:"")
                    // setdateeffectivefrom(response.data.effectivE_FROM?response.data.effectivE_FROM:"")
                    // setdateeffectiveto(response.data.effectivE_TO?response.data.effectivE_TO:"")
                    setreadmissiondate(response.data.readmissioN_DATE?response.data.readmissioN_DATE:"")
                    setreadsession(response.data.readmissioN_SESSION_ID?response.data.readmissioN_SESSION_ID:"")
                    setapplicationstatusid(response.data.attributE11?response.data.attributE11:"")
                    setduereason(response.data.attributE12?response.data.attributE12:"")
                    const [day, month, year] = response.data.attributE13.split('/');
                    setdateeffectivefrom(response.data.attributE13?new Date(`${month}/${day}/${year}`):"")
                    const [day1, month1, year1] = response.data.attributE14.split('/');
                    setdateeffectiveto(response.data.attributE14?new Date(`${month}/${day}/${year}`):"")
                    setallowmarkid(response.data.attributE15?response.data.attributE15:"")
                    setallowSecondSemid(response.data.attributE16?response.data.attributE16:"")
                
            }

          });
          axios.get(`https://localhost:7229/api/StudentEntry/GetStudentPreviousCollectionHistory?studentHeaderId=${HId}`, headers)
            .then(function (response2) {
                if (response2.status == 200){
                    setstuPrvsBillresponse(response2.data)
                }
            });
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
          } else {
            console.error(`Error: ${err.message}`);
          }
        }
      }
      
      const handleRowClick= async (myitem)=>{
        console.log(stuSearchInforesponse)
        setIsReadmission(false)
        setsearchpopulatedata({...searchpopulatedata,["headerid"]:myitem.headerid})
        await GetStudentsInfoBySelectedSearchValue(myitem.studentHeaderId)
        
    }
    
    

    // function setsessionfunc(myval){
    //     setdrpsession(myval)
        
    // }

    function DrpdownValueSet(res,myval,setter){
        const matchedItem = res.find(
            (item) => (item.id == myval)
          );
          if (matchedItem) {
            setter(matchedItem.opt);
            
          } else {
            setter("");
          }
    }
    function DrpdownValueSetForMarkAllow(res,myval,setter){
        const matchedItem = res.find(
            (item) => (item.opt == myval)
          );
          if (matchedItem) {
            setter(matchedItem.opt);
            
          } else {
            setter("");
          }
    }
  const [sectioncurrent,setsectioncurrent] = useState("")
  const [clrdrp,setclrdrp] = useState(false)
    useEffect(()=>{
        if(clrdrp==true){
        }else{
            DrpdownValueSet(sessionresponse,stuInforesponse.admissioN_SESSION_ID,setdrpsession)
            DrpdownValueSet(sessionresponse,stuInforesponse.sessioN_ID,setsessioncurrent)
            DrpdownValueSet(genderresponse,stuInforesponse.gender,setgender)
            DrpdownValueSet(classresponse,stuInforesponse.admissioN_CLASS_ID,setclassoptions)
            DrpdownValueSet(classresponse,stuInforesponse.clasS_ID,setclasscurrent)
            DrpdownValueSet(sectionresponse,stuInforesponse.admissioN_SECTION_ID,setsectionoptions)
            DrpdownValueSet(sectionresponse,stuInforesponse.sectioN_ID,setsectioncurrent)
            DrpdownValueSet(shiftresponse,stuInforesponse.admissioN_SHIFT,setshiftoptions)
            DrpdownValueSet(shiftresponse,stuInforesponse.shift,setshiftcurrent)
            DrpdownValueSet(campusresponse,stuInforesponse.campuS_ID,setcampusoptions)
            DrpdownValueSet(countryresponse,stuInforesponse.preS_COUNTRY_ID,setpresentcountry)
            DrpdownValueSet(countryresponse,stuInforesponse.perM_COUNTRY_ID,setpermanentcountry)
            DrpdownValueSet(divisionresponse,stuInforesponse.preS_DIVISION_ID,setpresentdivision)
            DrpdownValueSet(divisionresponse,stuInforesponse.perM_DIVISION_ID,setpermanentdivision)
            DrpdownValueSet(districtresponse,stuInforesponse.preS_CITY_ID,setpresentdistrict)
            DrpdownValueSet(districtresponse,stuInforesponse.perM_CITY_ID,setpermanentdistrict)
            DrpdownValueSet(thanaresponse,stuInforesponse.preS_THANA_ID,setpresentthana)
            DrpdownValueSet(thanaresponse,stuInforesponse.perM_THANA_ID,setpermanentthana)
            DrpdownValueSet(statusresponse,stuInforesponse.status,setstatusoptions)
            DrpdownValueSet(bloodgroupresponse,stuInforesponse.blooD_GROUP,setbloodgroup)
            DrpdownValueSet(religionresponse,stuInforesponse.religion,setreligion)
            DrpdownValueSet(nationalityresponse,stuInforesponse.nationality,setnationality)
            DrpdownValueSet(applicationstatusresponse,stuInforesponse.attributE11,setapplicationstatus)
            DrpdownValueSet(sessionresponse,stuInforesponse.readmissioN_SESSION_ID,setreadsession)
            DrpdownValueSetForMarkAllow(allowmarkresponse,stuInforesponse.attributE15,setmarkallow)
            DrpdownValueSetForMarkAllow(allowSecondSemesterResultresponse,stuInforesponse.attributE16,setsecondsemesterallow)
    
        }
       
           
        
        

      },[stuInforesponse,sectioncurrent,clrdrp])

    const notification = {
        notification:true
    }
    const handlebrowse=()=>{

    }
    const [sessionresponse, setsessionrsponse] = useState([]);
    const [classresponse, setclassresponse] = useState([]);
    const [genderresponse, setgenderrsponse] = useState([]);
    const [statusresponse, setstatusresponse] = useState([]);
    const [sectionresponse, setsectionrsponse] = useState([]);
    const [shiftresponse, setshiftresponse] = useState([]);
    const [campusresponse, setcampusresponse] = useState([]);
    const [countryresponse, setcountryresponse] = useState([]);
    const [divisionresponse, setdivisionresponse] = useState([]);
    const [districtresponse, setdistrictresponse] = useState([]);
    const [thanaresponse, setthanaresponse] = useState([]);
    const [bloodgroupresponse, setbloodgroupresponse] = useState([]);
    const [religionresponse, setreligionresponse] = useState([]);
    const [nationalityresponse, setnationalityresponse] = useState([]);
    const [applicationstatusresponse, setapplicationstatusresponse] = useState([]);
    const [allowmarkresponse, setallowmarkresponse] = useState([]);
    const [allowSecondSemesterResultresponse, setallowSecondSemesterResultresponse] = useState([]);

    useEffect(() => {
        const fetchAllowSecondSemesterResult = async () => {
          try {
            const allowSecondSemesterResultresponse = await axios.get(
              "https://localhost:7229/api/Public/AllowSecondSemesterResult",
              {},
              headers
            );
            setallowSecondSemesterResultresponse(allowSecondSemesterResultresponse.data);
          } catch (err) {
            if (err.allowSecondSemesterResultresponse) {
              console.error(err.allowSecondSemesterResultresponse.data);
              console.log(err.allowSecondSemesterResultresponse.status);
              console.log(err.allowSecondSemesterResultresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchAllowSecondSemesterResult();
      }, []);
    useEffect(() => {
        const fetchAllowMark = async () => {
          try {
            const allowmarkresponse = await axios.get(
              "https://localhost:7229/api/Public/AllowMarkDropDown",
              {},
              headers
            );
            setallowmarkresponse(allowmarkresponse.data);
          } catch (err) {
            if (err.allowmarkresponse) {
              console.error(err.allowmarkresponse.data);
              console.log(err.allowmarkresponse.status);
              console.log(err.allowmarkresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchAllowMark();
      }, []);
    useEffect(() => {
        const fetchapplicationstatusDropdown = async () => {
          try {
            const applicationstatusresponse = await axios.get(
              "https://localhost:7229/api/Public/ApplicationStatusDropDown",
              {},
              headers
            );
            setapplicationstatusresponse(applicationstatusresponse.data);
          } catch (err) {
            if (err.setapplicationstatusresponse) {
              console.error(err.setapplicationstatusresponse.data);
              console.log(err.setapplicationstatusresponse.status);
              console.log(err.setapplicationstatusresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchapplicationstatusDropdown();
      }, []);
    useEffect(() => {
        const fetchthanaDropdown = async () => {
          try {
            const thanaresponse = await axios.get(
              "https://localhost:7229/api/Public/ThanaDropDown",
              {},
              headers
            );
            setthanaresponse(thanaresponse.data);
          } catch (err) {
            if (err.thanaresponse) {
              console.error(err.thanaresponse.data);
              console.log(err.thanaresponse.status);
              console.log(err.thanaresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchthanaDropdown();
      }, []);
    useEffect(() => {
        const fetchdistrictDropdown = async () => {
          try {
            const districtresponse = await axios.get(
              "https://localhost:7229/api/Public/DistrictDropDown",
              {},
              headers
            );
            setdistrictresponse(districtresponse.data);
          } catch (err) {
            if (err.districtresponse) {
              console.error(err.districtresponse.data);
              console.log(err.districtresponse.status);
              console.log(err.districtresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchdistrictDropdown();
      }, []);
    useEffect(() => {
        const fetchdivisionDropdown = async () => {
          try {
            const divisionresponse = await axios.get(
              "https://localhost:7229/api/Public/DivisionDropDown",
              {},
              headers
            );
            setdivisionresponse(divisionresponse.data);
          } catch (err) {
            if (err.divisionresponse) {
              console.error(err.divisionresponse.data);
              console.log(err.divisionresponse.status);
              console.log(err.divisionresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchdivisionDropdown();
      }, []);
    useEffect(() => {
        const fetchnationalityDropdown = async () => {
          try {
            const nationalityresponse = await axios.get(
              "https://localhost:7229/api/Public/NationalityDropDown",
              {},
              headers
            );
            setnationalityresponse(nationalityresponse.data);
          } catch (err) {
            if (err.nationalityresponse) {
              console.error(err.nationalityresponse.data);
              console.log(err.nationalityresponse.status);
              console.log(err.nationalityresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchnationalityDropdown();
      }, []);
    useEffect(() => {
        const fetchreligionDropdown = async () => {
          try {
            const religionresponse = await axios.get(
              "https://localhost:7229/api/Public/ReligionDropDown",
              {},
              headers
            );
            setreligionresponse(religionresponse.data);
          } catch (err) {
            if (err.religionresponse) {
              console.error(err.religionresponse.data);
              console.log(err.religionresponse.status);
              console.log(err.religionresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchreligionDropdown();
      }, []);
    useEffect(() => {
        const fetchbloodgroupDropdown = async () => {
          try {
            const bloodgroupresponse = await axios.get(
              "https://localhost:7229/api/Public/BloodGroupDropDown",
              {},
              headers
            );
            setbloodgroupresponse(bloodgroupresponse.data);
          } catch (err) {
            if (err.bloodgroupresponse) {
              console.error(err.bloodgroupresponse.data);
              console.log(err.bloodgroupresponse.status);
              console.log(err.bloodgroupresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchbloodgroupDropdown();
      }, []);
    useEffect(() => {
        const fetchstatusDropdown = async () => {
          try {
            const statusresponse = await axios.get(
              "https://localhost:7229/api/Public/StatusDropDown",
              {},
              headers
            );
            setstatusresponse(statusresponse.data);
          } catch (err) {
            if (err.statusresponse) {
              console.error(err.statusresponse.data);
              console.log(err.statusresponse.status);
              console.log(err.statusresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchstatusDropdown();
      }, []);
      useEffect(() => {
        const fetchstatusDropdown = async () => {
          try {
            const statusresponse = await axios.get(
              "https://localhost:7229/api/Public/StatusDropDown",
              {},
              headers
            );
            setstatusresponse(statusresponse.data);
          } catch (err) {
            if (err.statusresponse) {
              console.error(err.statusresponse.data);
              console.log(err.statusresponse.status);
              console.log(err.statusresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchstatusDropdown();
      }, []);
    useEffect(() => {
        const fetchsectionDropdown = async () => {
          try {
            const sectionresponse = await axios.get(
              "https://localhost:7229/api/Public/SectionDropDown",
              {},
              headers
            );
            setsectionrsponse(sectionresponse.data);
          } catch (err) {
            if (err.sectionresponse) {
              console.error(err.sectionresponse.data);
              console.log(err.sectionresponse.status);
              console.log(err.sectionresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchsectionDropdown();
      }, []);
    useEffect(() => {
        const fetchGenderDropdown = async () => {
          try {
            const genderresponse = await axios.get(
              "https://localhost:7229/api/Public/GenderDropDownForStudentEntry",
              {},
              headers
            );
            setgenderrsponse(genderresponse.data);
          } catch (err) {
            if (err.genderresponse) {
              console.error(err.genderresponse.data);
              console.log(err.genderresponse.status);
              console.log(err.genderresponse.header);
            } else {
              console.error(`Error: ${err.message}`);
            }
          }
        };
        fetchGenderDropdown();
      }, []);
    useEffect(() => {
        const fetchClassDropdown = async () => {
            try {
                const classresponse = await axios.get(
                    "https://localhost:7229/api/Public/Classlist",
                    {},
                    headers
                );
                setclassresponse(classresponse.data);
            } catch (err) {
                if (err.classresponse) {
                    console.error(err.classresponse.data);
                    console.log(err.classresponse.status);
                    console.log(err.classresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchClassDropdown();
    }, []);
    useEffect(() => {
        const fetchShitDropdown = async () => {
            try {
                const shiftresponse = await axios.get(
                    "https://localhost:7229/api/Public/ShiftDropDown",
                    {},
                    headers
                );
                setshiftresponse(shiftresponse.data);
            } catch (err) {
                if (err.shiftresponse) {
                    console.error(err.shiftresponse.data);
                    console.log(err.shiftresponse.status);
                    console.log(err.shiftresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchShitDropdown();
    }, []);
    useEffect(() => {
        const fetchCampusDropdown = async () => {
            try {
                const campusresponse = await axios.get(
                    "https://localhost:7229/api/Public/CampusDropDown",
                    {},
                    headers
                );
                setcampusresponse(campusresponse.data);
            } catch (err) {
                if (err.campusresponse) {
                    console.error(err.campusresponse.data);
                    console.log(err.campusresponse.status);
                    console.log(err.campusresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchCampusDropdown();
    }, []);
    useEffect(() => {
        const fetchCountryDropdown = async () => {
            try {
                const countryresponse = await axios.get(
                    "https://localhost:7229/api/Public/CountryDropDown",
                    {},
                    headers
                );
                setcountryresponse(countryresponse.data);
            } catch (err) {
                if (err.countryresponse) {
                    console.error(err.countryresponse.data);
                    console.log(err.countryresponse.status);
                    console.log(err.countryresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchCountryDropdown();
    }, []);



    useEffect(()=>{
        if(isSameaddress==true){
            setpermanentadholding(presentadholding)
            setpermanentadroad(presentadroad)
            setpermanentadarea(presentadarea)
            setpermanentpostcode(presentpostcode)
            setpermanentcountry(presentcountry)
            setpermanentdivision(presentdivision)
            setpermanentdistrict(presentdistrict)
            setpermanentthana(presentthana)
        }
    },[isSameaddress])

    const [fnationalid,setfnationalid] = useState()
    const [borderfnationalid,setborderfnationalid] = useState("")
    const [labelfnationalid,setlabelfnationalid] = useState("")
    const [fpassport,setfpassport] = useState()
    const [borderfpassport,setborderfpassport] = useState("")
    const [labelfpassport,setlabelfpassport] = useState("")
    const [fmobile,setfmobile] = useState()
    const [borderfmobile,setborderfmobile] = useState("")
    const [labelfmobile,setlabelfmobile] = useState("")
    const [fphone,setfphone] = useState()
    const [borderfphone,setborderfphone] = useState("")
    const [labelfphone,setlabelfphone] = useState("")
    const [feducation,setfeducation] = useState()
    const [borderfeducation,setborderfeducation] = useState("")
    const [labelfeducation,setlabelfeducation] = useState("")
    const [fedudetails,setfedudetails] = useState()
    const [borderfedudetails,setborderfedudetails] = useState("")
    const [labelfedudetails,setlabelfedudetails] = useState("")
    const [foccupation,setfoccupation] = useState()
    const [borderfoccupation,setborderfoccupation] = useState("")
    const [labelfoccupation,setlabelfoccupation] = useState("")
    const [foccudetails,setfoccudetails] = useState()
    const [borderfoccudetails,setborderfoccudetails] = useState("")
    const [labelfoccudetails,setlabelfoccudetails] = useState("")
    const [fofficeaddress,setfofficeaddress] = useState()
    const [borderfofficeaddress,setborderfofficeaddress] = useState("")
    const [labelfofficeaddress,setlabelfofficeaddress] = useState("")

    const [mnationalid,setmnationalid] = useState("")
    const [lgnationalid,setlgnationalid] = useState("")
    const [bordermnationalid,setbordermnationalid] = useState("")
    const [borderlgnationalid,setborderlgnationalid] = useState("")
    const [labelmnationalid,setlabelmnationalid] = useState("")
    const [labellgnationalid,setlabellgnationalid] = useState("")
    const [mpassport,setmpassport] = useState()
    const [bordermpassport,setbordermpassport] = useState("")
    const [labelmpassport,setlabelmpassport] = useState("")
    const [lgpassport,setlgpassport] = useState()
    const [borderlgpassport,setborderlgpassport] = useState("")
    const [labellgpassport,setlabellgpassport] = useState("")
    const [mmobile,setmmobile] = useState()
    const [bordermmobile,setbordermmobile] = useState("")
    const [labelmmobile,setlabelmmobile] = useState("")
    const [lgmobile,setlgmobile] = useState()
    const [borderlgmobile,setborderlgmobile] = useState("")
    const [labellgmobile,setlabellgmobile] = useState("")
    const [mphone,setmphone] = useState()
    const [bordermphone,setbordermphone] = useState("")
    const [labelmphone,setlabelmphone] = useState("")
    const [lgrelation,setlgrelation] = useState("")
    const [borderlgrelation,setborderlgrelation] = useState("")
    const [labellgrelation,setlabellgrelation] = useState("")
    const [meducation,setmeducation] = useState()
    const [bordermeducation,setbordermeducation] = useState("")
    const [labelmeducation,setlabelmeducation] = useState("")
    const [medudetails,setmedudetails] = useState()
    const [bordermedudetails,setbordermedudetails] = useState("")
    const [labelmedudetails,setlabelmedudetails] = useState("")
    const [moccupation,setmoccupation] = useState()
    const [bordermoccupation,setbordermoccupation] = useState("")
    const [labelmoccupation,setlabelmoccupation] = useState("")
    const [moccudetails,setmoccudetails] = useState()
    const [bordermoccudetails,setbordermoccudetails] = useState("")
    const [labelmoccudetails,setlabelmoccudetails] = useState("")
    const [mofficeaddress,setmofficeaddress] = useState()
    const [bordermofficeaddress,setbordermofficeaddress] = useState("")
    const [labelmofficeaddress,setlabelmofficeaddress] = useState("")

    const [bloodgroup,setbloodgroup] = useState("")
    const [labelbloodgroup,setlabelbloodgroup] = useState("")
    const [borderbloodgroup,setborderbloodgroup] = useState("")

    const [religion,setreligion] = useState("")
    const [labelreligion,setlabelreligion] = useState("")
    const [borderreligion,setborderreligion] = useState("")

    const [nationality,setnationality] = useState("")
    const [labelnationality,setlabelnationality] = useState("")
    const [bordernationality,setbordernationality] = useState("")

    const [stupassport,setstupassport] = useState("")
    const [labelstupassport,setlabelstupassport] = useState("")
    const [borderstupassport,setborderstupassport] = useState("")

    const [stubirthcertificate,setstubirthcertificate] = useState("")
    const [labelstubirthcertificate,setlabelstubirthcertificate] = useState("")
    const [borderstubirthcertificate,setborderstubirthcertificate] = useState("")

    const [stuemergencymedical,setstuemergencymedical] = useState("")
    const [labelstuemergencymedical,setlabelstuemergencymedical] = useState("")
    const [borderstuemergencymedical,setborderstuemergencymedical] = useState("")

    const [stumedicalhistory,setstumedicalhistory] = useState("")
    const [labelstumedicalhistory,setlabelstumedicalhistory] = useState("")
    const [borderstumedicalhistory,setborderstumedicalhistory] = useState("")

    const [applicationstatus,setapplicationstatus] = useState("")
    const [labelapplicationstatus,setlabelapplicationstatus] = useState("")
    const [borderapplicationstatus,setborderapplicationstatus] = useState("")

    const [dateeffectivefrom,setdateeffectivefrom] = useState("")
    const [labeldateeffectivefrom,setlabeldateeffectivefrom] = useState("")
    const [borderdateeffectivefrom,setborderdateeffectivefrom] = useState("")

    const [dateeffectiveto,setdateeffectiveto] = useState("")
    const [labeldateeffectiveto,setlabeldateeffectiveto] = useState("")
    const [borderdateeffectiveto,setborderdateeffectiveto] = useState("")

    const [duereason,setduereason] = useState("")
    const [labelduereason,setlabelduereason] = useState("")
    const [borderduereason,setborderduereason] = useState("")

    const [markallow,setmarkallow] = useState("")
    const [secondsemesterallow,setsecondsemesterallow] = useState("")

const [readsession,setreadsession] = useState("")
const [labelreadsession,setlabelreadsession] = useState("")
const [borderreadsession,setborderreadsession] = useState(false)

const [reaadmissiondate,setreadmissiondate]=useState(null)
const [borderreaadmissiondate,setborderreadmissiondate]=useState("")
const [labelreaadmissiondate,setlabelreadmissiondate]=useState("")

const [borderslastname,setborderslastname]=useState("")

const [hideme,sethideme] = useState(false)


    const handleSameaddress = event => {
        if (event.target.checked) {
          console.log('✅ Checkbox is checked');
        } else {
          console.log('⛔️ Checkbox is NOT checked');
        }
        setisSameaddress(current => !current);
      };

      const handlePermissionSave=()=>{
        console.log(allowSecondSemid)
        try{
            axios.post(`https://localhost:7229/api/StudentEntry/SecondSemResultInfoSave?headerId=${headerid}&AllowSecondSemResult=${allowSecondSemidforapi}`, headers)
            .then((response) => {
                    console.log(response);
                    if (response.data == 1 || response.status == 200) {
                        // navigate("/submitSuccess");
                        console.log('ok')
                        toast.success('Your Changes Have Been Saved', {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            });
                      } else {
                        toast.error('Error Occured', {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            });
                      }
                    })
        }catch (err) {
              if (err.response) {
                console.error(err.response.data);
                console.log(err.response.status);
                console.log(err.response.header);
              } else {
                console.error(`Error: ${err.message}`);
              }
        }
      }

      const handleAllowMarkSave=()=>{
        try{
            axios.post(`https://localhost:7229/api/StudentEntry/MarkAllowanceSave?headerId=${headerid}&AllowMarkValue=${allowmarkid}`, headers)
            .then((response) => {
                    console.log(response);
                    if (response.data == 1 || response.status == 200) {
                        // navigate("/submitSuccess");
                        console.log('ok')
                        toast.success('Your Changes Have Been Saved', {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            });
                      } else {
                        toast.error('Error Occured', {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            });
                      }
                    })
        }catch (err) {
              if (err.response) {
                console.error(err.response.data);
                console.log(err.response.status);
                console.log(err.response.header);
              } else {
                console.error(`Error: ${err.message}`);
              }
        }
      }


    const drpfunctionsecondsemesterallow=(myval,myid)=>{
        setsecondsemesterallow(myval)
        setallowSecondSemid(myval)
        setallowSecondSemidforapi(myid)
        
    }
    const drpfunctionmarkallow=(myval,myid)=>{
        setmarkallow(myval)
        setallowmarkid(myval)
        
    }
    const drpfuncapplicationstatus=(myval,myid)=>{
        setapplicationstatus(myval)
        setapplicationstatusid(myid.toString())
        
    }
    const drpfuncnationality=(myval,myid)=>{
        setnationality(myval)
        setnationalityid(myid)
        
    }
    const drpfuncreligion=(myval,myid)=>{
        setreligion(myval)
        setreligionid(myid.toString())
        
    }
    const drpfuncbloodgroup=(myval,myid)=>{
        setbloodgroup(myval)
        setbloodgroupid(myid)
        
    }
    const drpfuncpcountry=(myval,myid)=>{
        setpresentcountry(myval)
        setprescountryid(myid)
        
    }
    const drpfuncpdivision=(myval,myid)=>{
        setpresentdivision(myval)
        setpresdivisionid(myid)
        
    }
    const drpfuncpdisctict=(myval,myid)=>{
        setpresentdistrict(myval)
        setprescityid(myid)
        
    }
    const drpfuncpthana=(myval,myid)=>{
        setpresentthana(myval)
        setpresthanaid(myid)
        
    }
    const drpfuncprcountry=(myval,myid)=>{
        setpermanentcountry(myval)
        setpermcountryid(myid)
        
    }
    const drpfuncprdivision=(myval,myid)=>{
        setpermanentdivision(myval)
        setpermdivisionid(myid)
        
    }
    const drpfuncprdisctict=(myval,myid)=>{
        setpermanentdistrict(myval)
        setpermcityid(myid)
        
    }
    const drpfuncprthana=(myval,myid)=>{
        setpermanentthana(myval)
        setpermthanaid(myid)
        
    }
    
   

    const handleChangereAdmission = event => {
        if (event.target.checked) {
            setIsReadmission(true);
          console.log('✅ Readmission is checked');
        } else {
            setIsReadmission(false);
          console.log('⛔️ Readmission is NOT checked');
        }
        //setIsReadmission(current => !current);
      };

      const handleDateofbirthstu = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setdateofbirthstu(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }


    }

    // const drpfunctionresesstion = (mystatusval, resessionid) => {
    //     setresession(resessionid)
    // }

    const drpfunctiongender = (myval, _genderid) => {
        setgender(myval)
        setgenderid(_genderid)
        
    }

    const handleDateeffectivefrom = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setdateeffectivefrom(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }


    }
    const handleDateeffectiveto = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setdateeffectiveto(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }


    }
    const handlereadmissiondatestu = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setreadmissiondate(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }


    }
    const handleDateofleavestu = (newvaldob) => {

        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setleavedate(moment(dtdobfinalc).format("YYYY-MM-DD"))
        }


    }


    const drpfunctionsesstion = (mysesstion, sesstionid) => {
        setdrpsession(mysesstion)
        setadmsessionid(sesstionid)
        
    }
    const drpfunctionsesstioncurrent = (mysesstion, sesstionid) => {
        setsessioncurrent(mysesstion)
        setcurrentsessionid(sesstionid)
        
    }
    const drpfuncClass = (myclassval, classid) => {
        setclassoptions(myclassval)
        setadmclassid(classid)
        
    }
    const drpfuncClasscurrent = (myclassval, classid) => {
        setclasscurrent(myclassval)
        setcurrentclassid(classid)
        
    }
    const drpfuncSection = (mysectionval, sectionid) => {
        setsectionoptions(mysectionval)
        setadmsectionid(sectionid)
        
    }
    const drpfuncSectioncurrent = (mysectionval, sectionid) => {
        setsectioncurrent(mysectionval)
        setcurrentsectionid(sectionid)
        
    }
    const drpfuncShift = (myshiftval, shiftid) => {
        setshiftoptions(myshiftval)
        setadmshiftid(shiftid)
        
    }
    const drpfuncshiftcurrent = (mysectionval, sectionid) => {
        setshiftcurrent(mysectionval)
        setcurrentshiftid(sectionid)
        
    }
    const drpfuncStatus = (mystatusval, _statusid) => {
        setstatusoptions(mystatusval)
        setstatusid(_statusid)
        
    }

    const drpfuncCampus = (myclassval, _campusid) => {
        setcampusoptions(myclassval)
        setcurrentcampusid(_campusid)
        
    }
        const handleDateofadmission = (newvaldob) => {

            if (newvaldob != null) {

                var dtofbrth = newvaldob.$M + 1;
                var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
                setdateofadmission(moment(dtdobfinalc).format("YYYY-MM-DD"))
            }


        }

       
        
        const handleClearBtn=()=>{
            setstuInforesponse([])
            setstuPrvsBillresponse([])
            setid("")
            setheaderid("")
            setsfirstname("")
            setsmiddlename("")
            setslastname("")
            setnickname("")            
            setgenderid("")
            setproxnum("")
            setdateofbirthstu(null)
            setsemail("")
            setsmobile("")
            setsmobileres("")
            setdateofadmission(null)           
            setleavedate(null)
            setsremarks("")
            setreadmissiondate(null)
            setstatusoptions("Active")  
            setpresentadholding("")
            setpermanentadholding("")
            setpresentadroad("")
            setpermanentadroad("")
            setpresentadarea("")    
            setpermanentadarea("")
            setpresentpostcode("")
            setpermanentpostcode("")
            setffirstname("")    
            setfmiddlename("")
            setflastname("")
            setfmobile("")
            setfphone("")
            setfnationalid("")
            setfpassport("")
            setfeducation("")
            setfedudetails("")
            setfoccupation("")
            setfoccudetails("")
            setfofficeaddress("")    
            setmfirstname("")
            setmmiddlename("")
            setmlastname("")
            setmmobile("")  
            setmphone("")
            setmnationalid("")
            setmpassport("")
            setmeducation("")
            setmedudetails("")
            setmoccupation("")
            setmoccudetails("")
            setmofficeaddress("") 
            setlgfirstname("")
            setlgmiddlename("")
            setlglastname("")
            setlgmobile("") 
            setlgrelation("")
            setlgnationalid("")
            setlgpassport("") 
            setstupassport("")
            setstubirthcertificate("")
            setstuemergencymedical("")
            setstumedicalhistory("")
            setdateeffectivefrom(null)
            setdateeffectiveto(null)
            setduereason("")
            setIsReadmission(false)   
        }
     

        const apiUrl = `https://localhost:7229/api/StudentEntry/UpdateStudentInformation?IsReAdmission=${isReadmission? isReadmission : false}`;
        const handleSave=()=>{

            if (dateofadmission.length == 0) {
                setborderdateofadmission(true);
                setlabeladmissiondate("Date is required");
              } else {
                setborderdateofadmission(false);
                setlabeladmissiondate("");

              }
              if(!drpsesstionselect){
                setbordersession("err")
                setlabelsession("Session Required")
            }else{
                setbordersession("")
                setlabelsession("")
            }
            if(!classoptions){
                setborderclass("err")
                setlabelclass("Class Required")
            }else{
                setborderclass("")
                setlabelclass("")
            }
            if(!sectionoptions){
                setbordersection("err")
                setlabelsection("Section Required")
            }else{
                setbordersection("")
                setlabelsection("")
            }
            if(!shiftoptions){
                setbordershift("err")
                setlabelshift("Shift Required")
            }else{
                setbordershift("")
                setlabelshift("")
            }
            if(!sessioncurrent){
                setbordersessioncurrent("err")
                setlabelsessioncurrent("Current Session Required")
            }else{
                setbordersessioncurrent("")
                setlabelsessioncurrent("")
            }
            if(!classcurrent){
                setborderclasscurrent("err")
                setlabelclasscurrent("Current Class Required")
            }else{
                setborderclasscurrent("")
                setlabelclasscurrent("")
            }
            if(!sectioncurrent){
                setbordersectioncurrent("err")
                setlabelsectioncurrent("Section Required")
            }else{
                setbordersectioncurrent("")
                setlabelsectioncurrent("")
            }
            if(!shiftcurrent){
                setbordershiftcurrent("err")
                setlabelshiftcurrent("C. Shift Required")
            }else{
                setbordershiftcurrent("")
                setlabelshiftcurrent("")
            }
            if(!campusoptions){
                setbordercampus("err")
                setlabelcampus("Campus Required")
            }else{
                setbordercampus("")
                setlabelcampus("")
            }
            // if(!leavedate){
            //     setborderleavedt(true)
            //     setlabeldateofleavestu("Leave Date Required")
            // }else{
            //     setborderleavedt(false)
            //     setlabeldateofleavestu("")
            // }
            // if(!reaadmissiondate){
            //     setborderreadmissiondate(true)
            //     setlabelreadmissiondate("Date Required")
            // }else{
            //     setborderreadmissiondate(false)
            //     setlabelreadmissiondate("")
            // }
            // if(!resession){
            //     setlabelresession("Re-session required")
            //     setborderresession("err")
            // }else{
            //     setlabelresession("")
            //     setborderresession("")
            // }
            if(!sfirstname){
                setlabelsfirstname("First Name Required")
                setbordersfirstname(true)
            }else{
                setlabelsfirstname("")
                setbordersfirstname(false)

            }
            if(!smiddlename){
                setlabelsmiddlename("First Name Required")
                setbordersmiddlename(true)
            }else{
                setlabelsmiddlename("")
                setbordersmiddlename(false)

            }
            if(!slastname){
                setlabelslastname("Last Name Required")
                setborderslastname(true)
            }else{
                setlabelslastname("")
                setborderslastname(false)

            }
            if(!gender){
                setlabelgender("Gender Required")
                setbordergender("err")
            }else{
                setlabelgender("")
                setbordergender("")

            }
            if(!dateofbirthstu){
                setlabeldateofbirthstu("Date Of Birth Required")
                setbordersbirthdt(true)
            }else{
                setlabeldateofbirthstu("")
                setbordersbirthdt(false)

            }
            if(!semail){
                setlabelsemail("Email Required")
                setbordersemail(true)
            }else{
                setlabelsemail("")
                setbordersemail(false)

            }
            if(!smobile){
                setlabelsmobile("Mobile Required")
                setbordersmobile(true)
            }else{
                setlabelsmobile("")
                setbordersmobile(false)

            }
            // if(!statusoptions){
            //     setlabelstatus("Status Required")
            //     setborderstatus("err")
            // }else{
            //     setlabelstatus("")
            //     setborderstatus("")

            // }
            if(!ffirstname){
                setlabelffirstname("First Name Required")
                setborderffirstname("err")
            }else{
                setlabelffirstname("")
                setborderffirstname("")

            }
            if(!flastname){
                setlabelflastname("Last Name Required")
                setborderflastname("err")
            }else{
                setlabelflastname("")
                setborderflastname("")

            }
            if(!mfirstname){
                setlabelmfirstname("First Name Required")
                setbordermfirstname("err")
            }else{
                setlabelmfirstname("")
                setbordermfirstname("")

            }
            if(!mlastname){
                setlabelmlastname("Last Name Required")
                setbordermlastname("err")
            }else{
                setlabelmlastname("")
                setbordermlastname("")

            }
            if(!proxnum){
                setlabelproxnum("Prox number Required")
                setborderproxnum(true)
            }else{
                setlabelproxnum("")
                setborderproxnum(false)

            }

            console.log(stuInforesponse);
            console.log(nationalityid)
            const finalArr={
                "studenT_HEADER_ID": headerid,
                "studenT_ID": id,
                "firsT_NAME": sfirstname,
                "middlE_NAME": smiddlename,
                "lasT_NAME": slastname,
                "nicK_NAME": nickname,
                "preS_HOLDING_NO": presentadholding,
                "preS_STREET": presentadroad,
                "preS_AREA": presentadarea,
                "preS_THANA_ID": presthanaid?presthanaid: 0,
                "preS_POST_CODE": presentpostcode,
                "preS_CITY_ID": prescityid?prescityid: 0,
                "preS_DIVISION_ID": presdivisionid? presdivisionid: 0,
                "preS_COUNTRY_ID": prescountryid?prescountryid: 0,
                "perM_HOLDING_NO": permanentadholding,
                "perM_STREET": permanentadroad,
                "perM_AREA": permanentadarea,
                "perM_POST_CODE": permanentpostcode,
                "perM_THANA_ID": permthanaid?permthanaid : 0,
                "perM_CITY_ID": permcityid ? permcityid : 0,
                "perM_DIVISION_ID": permdivisionid? permdivisionid : 0,
                "perM_COUNTRY_ID": permcountryid? permcountryid : 0,
                "dob": dateofbirthstu?dateofbirthstu: "",
                "admissioN_DATE": dateofadmission? dateofadmission :"",
                "admissioN_SESSION_ID": admsessionid?admsessionid : 0,
                "admissioN_CLASS_ID":  admclassid?admclassid:0,
                "admissioN_SECTION_ID": admsectionid?admsectionid:0,
                "admissioN_SHIFT": admshiftid?admshiftid:0,
                "sessioN_ID": currentsessionid?currentsessionid : 0,
                "clasS_ID": currentclassid?currentclassid : 0,
                "sectioN_ID": currentsectionid ? currentsectionid : 0,
                "shift": currentshiftid ? currentshiftid : 0,
                "campuS_ID": currentcampusid ? currentcampusid : 0,
                
                "enD_DATE": leavedate ?leavedate :null,
                "status": statusid ? statusid : 0,
                "gender": genderid ? genderid : "",
                "religion": religionid ? religionid : "",
                "reS_PHONE": smobileres? smobileres:"",
                "mobile": smobile? smobile:"",
                "email": semail? semail:"",
                "blooD_GROUP": bloodgroup?bloodgroup:stuInforesponse.blooD_GROUP,
                "nationality": nationalityid?nationalityid.toString():0,
                
                "birtH_CERTIFICATE_NO": stubirthcertificate,
                "passporT_NO": stupassport,
                "medicaL_HISTORY": stumedicalhistory,
                "emergencY_MEDICAL_ACTION": stuemergencymedical,
                "fatheR_FIRST_NAME": ffirstname,
                "fatheR_MIDDLE_NAME": fmiddlename,
                "fatheR_LAST_NAME": flastname,
                "fatheR_EDUCATION": feducation,
                "fatheR_EDUCATION_DETAILS": fedudetails,
                "fatheR_OCCUPATION": foccupation,
                "fatheR_OCCUPATION_DETAILS": foccudetails,
                "fatheR_OFFICE_ADDRESS": fofficeaddress,
                "fatheR_OFFICE_PHONE":fphone,
                "fatheR_MOBILE": fmobile,
                "fatheR_NATIONAL_ID":fnationalid,
                "fatheR_PASSPORT_NO":fpassport,
                "motheR_FIRST_NAME": mfirstname,
                "motheR_MIDDLE_NAME": mmiddlename,
                "motheR_LAST_NAME": mlastname,
                "motheR_EDUCATION": meducation,
                "motheR_EDUCATION_DETAILS": medudetails,
                "motheR_OCCUPATION": moccupation,
                "motheR_OCCUPATION_DETAILS": moccudetails,
                "motheR_OFFICE_ADDRESS": mofficeaddress,
                "motheR_OFFICE_PHONE": mphone,
                "motheR_MOBILE": mmobile,
                "motheR_NATIONAL_ID": mnationalid,
                "motheR_PASSPORT_NO": mpassport,
                "loC_GUARDIAN_FIRST_NAME": lgfirstname,
                "loC_GUARDIAN_MIDDLE_NAME": lgmiddlename,
                "loC_GUARDIAN_LAST_NAME": lglastname,
                "loC_GUARDIAN_RELATIONSHIP": lgrelation,
                "loC_GUARDIAN_MOBILE": lgmobile,
                "locaL_GURDIAN_NATIONAL_ID": lgnationalid,
                "locaL_GURDIAN_PASSPORT_NO": lgpassport,
                "studenT_PHOTO_PATH": stuimgvar,
                "proximitY_NUM": proxnum,
                "exiT_REASONS": "",
                "readmissioN_DATE": reaadmissiondate?reaadmissiondate:null,
                "readmissioN_SESSION_ID": stuInforesponse.readmissioN_SESSION_ID? stuInforesponse.readmissioN_SESSION_ID : 0,
                "attributE11": applicationstatusid?applicationstatusid:"",
                "attributE12": duereason?duereason : "",
                "attributE13": dateeffectivefrom? moment(dateeffectivefrom).format("YYYY-MM-DD"): "",
                "attributE14": dateeffectiveto? moment(dateeffectiveto).format("YYYY-MM-DD"): "",
                "attributE15": allowmarkid ? allowmarkid : "",
                "attributE16": allowSecondSemid ? allowSecondSemid : ""
              }
            console.log(finalArr)
            if(sfirstname &&
                slastname 
                // dateofadmission &&
                // drpsesstionselect &&
                // classoptions &&
                // sectionoptions &&
                // shiftoptions &&
                // sessioncurrent &&
                // classcurrent &&
                // sectioncurrent &&
                // shiftcurrent &&
                // campusoptions &&
                // gender &&
                // dateofbirthstu &&
                // semail &&
                // smobile &&
                // statusoptions &&
                // ffirstname &&
                // flastname &&
                // mfirstname &&
                // mlastname &&
                // proxnum
                ){
                    console.log("done")
                    
                    axios.post(apiUrl, finalArr, headers)
                    .then((response) => {
                    console.log(response);
                    if (response.data == 1 || response.status == 200) {
                        // navigate("/submitSuccess");
                        console.log('ok')
                        toast.success('Your Changes Have Been Saved', {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            });
                      } else {
                        toast.error('Error Occured', {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            });
                      }
                    })
                    .catch((error) => {
                    console.error(error);
                });
                }

        }

  return (
    <>
        <div className="f-flex flexvaluecomp stuentrymain">
            <SidebarOfAdash/>
            <ToastContainer />
            <div className="contentpartwidthwrapper" style={screenSize.dynamicHeight<925 ? {marginBottom:"75px"}:{}}>


            <div className=" contentflexvalue billcontent newadmissionentry">
            <div className="bottombarofsave">
                    <div className="wrapper newadmissionentrywrap">
                    <button onClick={handleClearBtn}>Clear</button>

                    <button onClick={handleSave}>Save</button>

                    </div>
                </div>
            <div className="headerofadash billpart">
                <div className="left">
                    <div className="leftsidesearch">
                        <input type="text" value={searchkey} onChange={handleInputSearch} name="searchword" placeholder='Search Student'/>
                        <span onClick={handleSearchButton}>
                            <img src="./assets/images/dashboards/adminDashboard/bill/searchbutton.png" alt="" />
                        </span>
                    <div className= {searchkey.length>0?"searchtable d-block":"searchtable d-none"}>
                    <div className="wrapper">

                        <div className="billentrytoptable searchtablediv">
                        <table>
                            <thead>
                            <tr>
                            {
                                searchtableApi.heading.map((item,key)=>{
                                    return(
                                        <th key={key}>{item.head}</th>
                                    )
                                })
                            }
                        </tr>
                            </thead>
                        <tbody>

                        {
                            stuSearchInforesponse? stuSearchInforesponse.map((item,key)=>{
                                return(
                                    <tr style={{cursor:"pointer"}} onClick={()=>handleRowClick(item)}>
                                        <td>{item.studentHeaderId}</td>
                                        <td>{item.id}</td>

                                        {/* <HighlightRowText text={item.name} searchText={searchkey} /> */}
                                        <td>{item.name}</td>
                                        <td>{item.className}</td>
                                        <td>{item.section}</td>
                                        <td>{item.status}</td>

                                    </tr>
                                )
                            }) : "string"
                        }
                        </tbody>
                        </table>

                        </div>
                        </div>
                    </div>
                    </div>

                </div>
                <div className="right">
                    {
                        notification.notification==true?
                        <div className="belldiv">
                            <BiBell/>
                        </div>
                        :
                        <BiBell/>
                     }
                    <div className="displaypic">
                        <img src="./assets/images/dashboards/adminDashboard/header/DP.png" alt="" />
                    </div>
                    <div className="nameandid">
                        <h5>{adminHeaderApi.name}</h5>
                        <p>ID {adminHeaderApi.id}</p>
                    </div>
                </div>
            </div>

                <div className={screenSize.dynamicWidth>1200? "stumainentrybox":"stuforlgdevice"}>
                <h3>Student Entry</h3>
                <div className="whitebox pb0">

                    <Row>
                        <Col lg={5}>
                            <Row>
                            <Col lg={12} className='pe-0'>
                            <div className="studentinfo">
                        <div className="billbox paymentcollectbox stuCommonformbox mt-0">
                            <div className="titlewithwhite">
                                <p>Student</p>
                            </div>

                            <Row>
                                <Col lg={6} className='pr5'>
                                    <div className="basicinputfield h35p">
                                        <p>ID</p>
                                        <div className="inputgap h35">
                                            <input disabled style={borderid ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={id} onChange={(e) => setid(e.target.value)} />
                                            <label>{labelid}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} className='pl5'>
                                    <div className="basicinputfield h35p">
                                        <p>Header ID</p>
                                        <div className="inputgap h35">
                                            <input disabled style={borderheaderid ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={headerid} onChange={(e) => setheaderid(e.target.value)} />
                                            <label>{labelheaderid}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='pe-0'>
                                    <div className="basicinputfield h35p">
                                        <p>First Name</p>
                                        <div className="inputgap h35">
                                            <input style={bordersfirstname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={sfirstname} onChange={(e) => setsfirstname(e.target.value)} />
                                            <label>{labelsfirstname}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='px10'>
                                    <div className="basicinputfield h35p">
                                        <p>Middle Name</p>
                                        <div className="inputgap h35">
                                            <input  style={false ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={smiddlename} onChange={(e) => setsmiddlename(e.target.value)} />
                                            {/* <label>{labelsmiddlename}</label> */}
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='ps-0'>
                                    <div className="basicinputfield h35p">
                                        <p>Last Name</p>
                                        <div className="inputgap h35">
                                            <input style={borderslastname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={slastname} onChange={(e) => setslastname(e.target.value)} />
                                            <label>{labelslastname}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='pr5'>
                                    <div className="basicinputfield h35p">
                                        <p>Nick Name</p>
                                        <div className="inputgap h35">
                                            <input style={bordernickname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={nickname} onChange={(e) => setnickname(e.target.value)} />
                                            <label>{labelnickname}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='pl5'>
                                <div className="basicinputfield h35p">
                                    <p>Gender</p>
                                    <div className="inputgap h35">
                                        <div className="dropdownwrapper">
                                            <Dropdown2 err={bordergender} func={drpfunctiongender} myplaceholder={gender}fontsize="12" fontfamily="'Poppins', sans-serif" options={genderresponse} />
                                        </div>
                                        <label>{labelgender}</label>

                                    </div>
                                </div>
                                </Col>
                                <Col lg={4} className='pl5'>
                                    <div className="basicinputfield h35p">
                                        <p>Proximity Number</p>
                                        <div className="inputgap h35">
                                            <input style={borderproxnum ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={proxnum} onChange={(e) => setproxnum(e.target.value)} />
                                            <label>{labelproxnum}</label>
                                        </div>
                                    </div>
                                </Col>

                        </Row>
                        </div>
                            </div>
                            <div className="admissioninfo">
                    <div className="billbox paymentcollectbox stuCommonformbox mt-0">
                        <div className="titlewithwhite">
                            <p>Admission Entry</p>
                        </div>

                        <Row>
                            <Col lg={4} className='pe-0'>
                            <div className="basicinputfield h35p">
                                <p>Admission Date</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35">

                                        <DatePicker

                                            value={dateofadmission}
                                            onChange={(newvaldob) => handleDateofadmission(newvaldob)}
                                            renderInput={(params) => <TextField style={borderdateofadmission==true?{border:"1px solid #ED1C24",borderRadius:"5px"}:{}} {...params} inputProps={{
                                                ...params.inputProps,
                                                placeholder: ""
                                            }} error={false} />}
                                        />
                                        <label>{labeladmissiondate}</label>


                                    </div>
                                </LocalizationProvider>
                            </div>
                        </Col>
                        <Col lg={8} className='pl10'>
                        <div className="basicinputfield h35p">
                            <p>Select Session</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper">
                                    <Dropdown2 err={bordersession} func={drpfunctionsesstion} myplaceholder={drpsesstionselect}fontsize="12" fontfamily="'Poppins', sans-serif" options={sessionresponse} />
                                </div>
                                <label>{labelsession}</label>

                            </div>
                        </div>
                        </Col>
                        <Col lg={4} className='pe-0'>
                        <div className="basicinputfield h35p">
                            <p>Class</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper scrollabledrp" >
                                    <Dropdown2 err={borderclass} func={drpfuncClass} myplaceholder={classoptions} fontsize="12" fontfamily="'Poppins', sans-serif" options={classresponse} />
                                </div>
                                <label>{labelclass}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={4} className='px10'>
                        <div className="basicinputfield h35p">
                            <p>Section</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper scrollabledrp" >
                                    <Dropdown2 err={bordersection} func={drpfuncSection} myplaceholder={sectionoptions} fontsize="12" fontfamily="'Poppins', sans-serif" options={sectionresponse} />
                                </div>
                                <label>{labelsection}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={4} className='ps-0'>
                        <div className="basicinputfield h35p">
                            <p>Shift</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper scrollabledrp" >
                                    <Dropdown2 err={bordershift} func={drpfuncShift} myplaceholder={shiftoptions}fontsize="12" fontfamily="'Poppins', sans-serif" options={shiftresponse} />
                                </div>
                                <label>{labelshift}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={4} className='pe-0'>
                        <div className="basicinputfield h35p">

                            <div className="inputgap h35">

                                    <div className="checkboxfull align-items-center">

                                <input
                                    type="checkbox"
                                    value={isReadmission}
                                    checked={isReadmission}
                                    onChange={handleChangereAdmission}
                                    id="remember"
                                    name="subscribe"
                                />
                                <span style={{fontSize:"12px"}}>Re Admission</span>
                                    </div>
                                </div>
                            </div>

                        </Col>

                        <Col lg={4} className='px10'>
                        <div className="basicinputfield h35p">
                            <p>Status</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper scrollabledrp" >
                                    <Dropdown2  err={borderstatus} func={drpfuncStatus} myplaceholder={statusoptions} fontsize="12" fontfamily="'Poppins', sans-serif" options={statusresponse} />
                                </div>
                                <label>{labelstatus}</label>
                            </div>
                        </div>
                        </Col>

                        </Row>
                        </div>

                    </div>
                            </Col>
                            </Row>
                        </Col>
                        <Col lg={7}>
                            <Row>
                                <Col lg={9} className='pe-0'>
                                <div className="studentinfo">
                        <div className="billbox paymentcollectbox stuCommonformbox mt-0">
                            <div className="titlewithwhite">
                                <p>Basic Info</p>
                            </div>

                            <Row>
                                <Col lg={6} className='pr5'>
                                <div className="basicinputfield h35p">
                                <p>Date of Birth</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35">

                                        <DatePicker

                                            value={dateofbirthstu}
                                            onChange={(newvaldob) => handleDateofbirthstu(newvaldob)}
                                            renderInput={(params) => <TextField style={bordersbirthdt==true?{border:"1px solid #ED1C24",borderRadius:"5px"}:{}} {...params} inputProps={{
                                                ...params.inputProps,
                                                placeholder: ""
                                            }} error={false} />}
                                        />
                                        <label>{labeldateofbirthstu}</label>


                                    </div>
                                </LocalizationProvider>
                            </div>
                                </Col>
                                <Col lg={6} className='pl5'>
                            <div className="basicinputfield h35p">
                                <p>Email</p>

                                    <div className="inputgap h35">

                                    <input style={bordersemail ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={semail} onChange={(e) => setsemail(e.target.value)} />
                                        <label>{labelsemail}</label>

                                    </div>

                            </div>
                            </Col>
                            <Col lg={6} className="pr5">
                            <div className="basicinputfield h35p">
                                <p>Mobile</p>

                                    <div className="inputgap h35">

                                    <input style={bordersmoblie ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={smobile} onChange={(e) => setsmobile(e.target.value)} />
                                        <label>{labelsmobile}</label>

                                    </div>

                            </div>
                            </Col>
                            <Col lg={6} className="pl5">
                            <div className="basicinputfield h35p">
                                <p>Res Phone</p>

                                    <div className="inputgap h35">

                                    <input style={bordersmoblieres ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={smobileres} onChange={(e) => setsmobileres(e.target.value)} />
                                        <label>{labelsmobileres}</label>

                                    </div>

                            </div>
                            </Col>

                        </Row>
                        </div>

                            </div>
                                </Col>
                               <Col lg={3}>
                                <div className="imgstu">
                                    <div className="overlay">
                                    <input
        type="file"
        accept="image/*" // Use appropriate MIME types if you have a specific file type in mind
        style={{ display: 'none' }} // Hide the default file input
        ref={fileInputRef}
        onChange={(e)=>handleFileChange(Array.from(e.target.files))}
      />
                                    <Purplebutton clickfunc={handleButtonClick} btnname="Browse" w="117px" h="40px" mt="0px"/>
                                    </div>
                                    {
                                        stuimgvar?
                                        <img className='w-100' src={stuimgvar} alt="Selected" />
                                        :
                                        <img className='w-100' 
                                    src={stuInforesponse.studenT_ID ? `./assets/images/Students/Session2023-2024/${stuInforesponse.studenT_ID}.png`: "./assets/images/dashboards/adminDashboard/student/studentimg.png"
                                    }/>
                                    // <img className='w-100' 
                                    // src={stuInforesponse.studenT_PHOTO_PATH
                                    //     ? `./assets/images/Students/Session2023-2024/${stuInforesponse.studenT_PHOTO_PATH}`
                                    //     : stuInforesponse
                                    //     ? `./assets/images/Students/Session2023-2024/${stuInforesponse.studenT_ID}.png`   
                                    //     : "./assets/images/dashboards/adminDashboard/student/studentimg.png"
                                    // }/>
                                    }
                                </div>
                               </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                <div className="billbox paymentcollectbox stuCommonformbox mt-0">
                            <div className="titlewithwhite">
                                <p>Current Info</p>
                            </div>

                            <Row>
                                <Col lg={6} className='pr5'>
                                <div className="basicinputfield h35p">
                            <p>Session</p>
                            <div className="inputgap h35">
                                    <div className="dropdownwrapper">
                                        <Dropdown2 err={bordersessioncurrent} func={drpfunctionsesstioncurrent} myplaceholder={sessioncurrent} fontsize="12" fontfamily="'Poppins', sans-serif" options={sessionresponse} />
                                    </div>
                                    <label>{labelsessioncurrent}</label>

                                </div>
                            </div>
                                </Col>
                                <Col lg={3} className='pl5'>
                                <div className="basicinputfield h35p">
                                    <p>Class</p>
                                    <div className="inputgap h35">
                                        <div className="dropdownwrapper scrollabledrp" >
                                            <Dropdown2 err={borderclasscurrent} func={drpfuncClasscurrent} myplaceholder={classcurrent} fontsize="12" fontfamily="'Poppins', sans-serif" options={classresponse} />
                                        </div>
                                        <label>{labelclasscurrent}</label>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} className=" pl5">
                                <div className="basicinputfield h35p">
                                <p>Section</p>
                                <div className="inputgap h35">
                                    <div className="dropdownwrapper scrollabledrp" >
                                        <Dropdown2 err={bordersectioncurrent} func={drpfuncSectioncurrent} myplaceholder={sectioncurrent} fontsize="12" fontfamily="'Poppins', sans-serif" options={sectionresponse} />
                                    </div>
                                    <label>{labelsectioncurrent}</label>
                                </div>
                        </div>
                            </Col>
                            <Col lg={3} className="pr5">
                                <div className="basicinputfield h35p">
                                <p>Shift</p>
                                <div className="inputgap h35">
                                    <div className="dropdownwrapper scrollabledrp" >
                                        <Dropdown2 err={bordershiftcurrent} func={drpfuncshiftcurrent} myplaceholder={shiftcurrent} fontsize="12" fontfamily="'Poppins', sans-serif" options={shiftresponse} />
                                    </div>
                                    <label>{labelshiftcurrent}</label>
                                </div>
                            </div>
                            </Col>
                            <Col lg={3} className='pl5 pr5'>
                            <div className="basicinputfield h35p">
                            <p>Campus</p>
                            <div className="inputgap h35">
                                <div className="dropdownwrapper scrollabledrp" >
                                    <Dropdown2 err={bordercampus} func={drpfuncCampus} myplaceholder={campusoptions}fontsize="12" fontfamily="'Poppins', sans-serif" options={campusresponse} />
                                </div>
                                <label>{labelcampus}</label>
                            </div>
                        </div>
                            </Col>
                            <Col lg={3} className="pl5">
                            <div className="basicinputfield h35p">
                                <p>Leave Date</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35">

                                        <DatePicker

                                            value={leavedate}
                                            onChange={(newvaldob) => handleDateofleavestu(newvaldob)}
                                            renderInput={(params) => <TextField style={borderleavedt==true?{border:"1px solid #ED1C24",borderRadius:"5px"}:{}} {...params} inputProps={{
                                                ...params.inputProps,
                                                placeholder: ""
                                            }} error={false} />}
                                        />
                                        <label>{labeldateofleavestu}</label>


                                    </div>
                                </LocalizationProvider>
                            </div>
                            </Col>

                            <Col lg={3}>
                            </Col>
                            <Col lg={12}>
                            <div className="basicinputfield h35p">
                                    <p>Remarks</p>
                                    <div className="inputgap h35">
                                        <input style={borderremarks ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={sremarks} onChange={(e) => setsremarks(e.target.value)} />
                                        <label>{labelsremarks}</label>
                                    </div>
                                </div>

                            </Col>


                            <Col lg={3} className="pr5">
                            <div className="basicinputfield h35p">
                                <p>Re Admission Date</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35">

                                        <DatePicker

                                            value={reaadmissiondate}
                                            onChange={(newvaldob) => handlereadmissiondatestu(newvaldob)}
                                            renderInput={(params) => <TextField style={borderreaadmissiondate==true?{border:"1px solid #ED1C24",borderRadius:"5px"}:{}} {...params} inputProps={{
                                                ...params.inputProps,
                                                placeholder: ""
                                            }} error={false} />}
                                        />
                                        <label>{labelreaadmissiondate}</label>


                                    </div>
                                </LocalizationProvider>
                            </div>
                            </Col>

                            <Col lg={6} className='pl5'>
                                    <div className="basicinputfield h35p">
                                    <p>Session</p>
                                    <div className="inputgap h35">

                                            <input disabled  type="text" value={readsession} onChange={(e) => setresession(e.target.value)} />
                                                    <label>{labelresession}</label>
                                        </div>
                                    </div>
                                </Col>
                                </Row>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                </div>
                </div>

                <div className={screenSize.dynamicWidth>1200? "stumainentrybox":"stuforlgdevice"}>

                <div className="whitebox mt15 tabsofstuentry mb90">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Row>
                    <Col sm={12}>
                    <Nav variant="pills" className="flex-row">
                        <Nav.Item>
                        <Nav.Link eventKey="first">Address</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="second">Father's Info</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="third">Mother's Info</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="fourth">Local Guardian</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="fifth">Others</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="sixth">Application for due</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="seventh">Status</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="eighth">Payment History</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="ninth">Permission</Nav.Link>
                        </Nav.Item>
                    </Nav>
                    </Col>
                    <Col sm={12}>
                    <Tab.Content >
                        <Tab.Pane eventKey="first" className="px75">
                            <div className="stumainentrybox2">
                                    <Row>
                                        <Col lg={6} className="pr7">
                                        <div className="billbox paymentcollectbox stuCommonformbox presentaddbox" >
                                            <div className="titlewithwhite">
                                                <p>Present Address</p>
                                            </div>

                                            <Row>
                                            <Col lg={4} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Holding</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpresentadholding ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={presentadholding} onChange={(e) => setpresentadholding(e.target.value)} />
                                                    <label>{labelsetpresentadholding}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={8} className='pl5'>
                                            <div className="basicinputfield h35p">
                                                <p>Road</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpresentroad ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={presentadroad} onChange={(e) => setpresentadroad(e.target.value)} />
                                                    <label>{labelsetpresentroad}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={8} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Area</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpresentarea ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={presentadarea} onChange={(e) => setpresentadarea(e.target.value)} />
                                                    <label>{labelsetpresentarea}</label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} className='pl5'>
                                            <div className="basicinputfield h35p">
                                                <p>Post Code</p>
                                                <div className="inputgap h35">
                                                    <input style={borderpresentpostcode ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={presentpostcode} onChange={(e) => setpresentpostcode(e.target.value)} />
                                                    <label>{labelpresentpostcode}</label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} className='pr5'>
                                        <div className="basicinputfield h35p">
                                            <p>Country</p>
                                            <div className="inputgap h35">
                                                <div className="dropdownwrapper h35">
                                                    <Dropdown2 err={borderpresentcountry} func={drpfuncpcountry} myplaceholder={presentcountry}fontsize="12" fontfamily="'Poppins', sans-serif" options={countryresponse} />
                                                </div>
                                            </div>
                                        </div>
                                        </Col>
                                        <Col lg={4} className='pr5 pl5'>
                                        <div className="basicinputfield h35p">
                                            <p>Division</p>
                                            <div className="inputgap h35">
                                                <div className="dropdownwrapper h35">
                                                    <Dropdown2 err={borderpresentdivision} func={drpfuncpdivision} myplaceholder={presentdivision} fontsize="12" fontfamily="'Poppins', sans-serif" options={divisionresponse} />
                                                </div>
                                            </div>
                                        </div>
                                        </Col>
                                        <Col lg={4} className='pl5'>
                                        <div className="basicinputfield h35p">
                                            <p>District</p>
                                            <div className="inputgap h35">
                                                <div className="dropdownwrapper h35">
                                                    <Dropdown2 err={borderpresentdistrict} func={drpfuncpdisctict} myplaceholder={presentdistrict} fontsize="12" fontfamily="'Poppins', sans-serif" options={districtresponse} />
                                                </div>
                                            </div>
                                        </div>
                                        </Col>
                                        <Col lg={4} className='pr5'>
                                        <div className="basicinputfield h35p">
                                            <p>Thana</p>
                                            <div className="inputgap h35">
                                                <div className="dropdownwrapper h35">
                                                    <Dropdown2 err={borderpresentthana} func={drpfuncpthana} myplaceholder={presentthana} fontsize="12" fontfamily="'Poppins', sans-serif" options={thanaresponse} />
                                                </div>
                                            </div>
                                        </div>
                                        </Col>
                                            </Row>
                                        </div>
                                        </Col>
                                        <Col lg={6} className="pl7">
        <div className="billbox paymentcollectbox stuCommonformbox">
            <div className="titlewithwhite">
                <p>permanent Address</p>
            </div>

            <Row>
            <Col lg={4} className='pr5'>
            <div className="basicinputfield h35p">
                <p>Holding</p>
                <div className="inputgap h35">
                    <input style={borderpermanentadholding ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={permanentadholding} onChange={(e) => setpermanentadholding(e.target.value)} />
                    <label>{labelsetpermanentadholding}</label>
                </div>
            </div>
        </Col>
            <Col lg={8} className='pl5'>
            <div className="basicinputfield h35p">
                <p>Road</p>
                <div className="inputgap h35">
                    <input style={borderpermanentroad ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={permanentadroad} onChange={(e) => setpermanentadroad(e.target.value)} />
                    <label>{labelsetpermanentroad}</label>
                </div>
            </div>
        </Col>
            <Col lg={8} className='pr5'>
            <div className="basicinputfield h35p">
                <p>Area</p>
                <div className="inputgap h35">
                    <input style={borderpermanentarea ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={permanentadarea} onChange={(e) => setpermanentadarea(e.target.value)} />
                    <label>{labelsetpermanentarea}</label>
                </div>
            </div>
        </Col>
        <Col lg={4} className='pl5'>
            <div className="basicinputfield h35p">
                <p>Post Code</p>
                <div className="inputgap h35">
                    <input style={borderpermanentpostcode ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={permanentpostcode} onChange={(e) => setpermanentpostcode(e.target.value)} />
                    <label>{labelpermanentpostcode}</label>
                </div>
            </div>
        </Col>
        <Col lg={4} className='pr5'>
    <div className="basicinputfield h35p">
        <p>Country</p>
        <div className="inputgap h35">
            <div className="dropdownwrapper h35">
                <Dropdown2 err={borderpermanentcountry} func={drpfuncprcountry} myplaceholder={permanentcountry}fontsize="12" fontfamily="'Poppins', sans-serif" options={countryresponse} />
            </div>
        </div>
    </div>
    </Col>
    <Col lg={4} className='pr5 pl5'>
    <div className="basicinputfield h35p">
        <p>Division</p>
        <div className="inputgap h35">
            <div className="dropdownwrapper h35">
                <Dropdown2 err={borderpermanentdivision} func={drpfuncprdivision} myplaceholder={permanentdivision} fontsize="12" fontfamily="'Poppins', sans-serif" options={divisionresponse} />
            </div>
        </div>
    </div>
    </Col>
    <Col lg={4} className='pl5'>
    <div className="basicinputfield h35p">
        <p>District</p>
        <div className="inputgap h35">
            <div className="dropdownwrapper h35">
                <Dropdown2 err={borderpermanentdistrict} func={drpfuncprdisctict} myplaceholder={permanentdistrict} fontsize="12" fontfamily="'Poppins', sans-serif" options={districtresponse} />
            </div>
        </div>
    </div>
    </Col>
    <Col lg={4} className='pr5'>
    <div className="basicinputfield h35p">
        <p>Thana</p>
        <div className="inputgap h35">
            <div className="dropdownwrapper h35">
                <Dropdown2 err={borderpermanentthana} currentID={stuInforesponse.perM_THANA_ID?stuInforesponse.perM_THANA_ID:0} func={drpfuncprthana} myplaceholder={permanentthana} fontsize="12" fontfamily="'Poppins', sans-serif" options={thanaresponse} />
            </div>
        </div>
    </div>
    </Col>
    <Col lg={12}>
    <div className="checkboxfull d-flex " style={{marginBottom:"25px"}}>

        <input
        type="checkbox"
        value={isSameaddress}
        onChange={handleSameaddress}
        id="remember"
        name="subscribe"
        />
        <span style={{fontSize:"12px",transform:"translateY(2px)"}}>Same As Present Adress</span>


        </div>
    </Col>
            </Row>
        </div>
                                    </Col>
                                    </Row>

                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second"  className="px75">
                            <Row>

                        <Col lg={6} className="pr7">
                                        <div className="billbox paymentcollectbox stuCommonformbox">
                                            <div className="titlewithwhite">
                                                <p>Name</p>
                                            </div>

                                            <Row>
                                            <Col lg={4} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>First</p>
                                                <div className="inputgap h35">
                                                    <input style={borderffirstname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={ffirstname} onChange={(e) => setffirstname(e.target.value)} />
                                                    <label>{labelffirstname}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={4} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Middle</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfmiddlename ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={fmiddlename} onChange={(e) => setfmiddlename(e.target.value)} />
                                                    <label>{labelfmiddlename}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={4} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Last</p>
                                                <div className="inputgap h35">
                                                    <input style={borderflastname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={flastname} onChange={(e) => setfmiddlename(e.target.value)} />
                                                    <label>{labelflastname}</label>
                                                </div>
                                            </div>
                                        </Col>

                                            </Row>
                                        </div>
                                        <div className="billbox paymentcollectbox stuCommonformbox">
                                            <div className="titlewithwhite">
                                                <p>Identity</p>
                                            </div>

                                            <Row>
                                            <Col lg={6} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>National ID</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfnationalid ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={fnationalid} onChange={(e) => setfnationalid(e.target.value)} />
                                                    <label>{labelfnationalid}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={6} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Passport</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfpassport ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={fpassport} onChange={(e) => setfpassport(e.target.value)} />
                                                    <label>{labelfpassport}</label>
                                                </div>
                                            </div>
                                        </Col>


                                            </Row>
                                        </div>
                        </Col>
                        <Col lg={6} className="pr7">
                                        <div className="billbox paymentcollectbox stuCommonformbox">
                                            <div className="titlewithwhite">
                                                <p>Contact</p>
                                            </div>

                                            <Row>
                                            <Col lg={6} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Mobile</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfmobile ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={fmobile} onChange={(e) => setfmobile(e.target.value)} />
                                                    <label>{labelfmobile}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={6} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Phone</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfphone ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={fphone} onChange={(e) => setfphone(e.target.value)} />
                                                    <label>{labelfphone}</label>
                                                </div>
                                            </div>
                                        </Col>


                                            </Row>
                                        </div>
                                        <div className="billbox paymentcollectbox stuCommonformbox">
                                            <div className="titlewithwhite">
                                                <p>Education</p>
                                            </div>

                                            <Row>
                                            <Col lg={6} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Education</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfeducation ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={feducation} onChange={(e) => setfeducation(e.target.value)} />
                                                    <label>{labelfeducation}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={6} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Details</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfedudetails ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={fedudetails} onChange={(e) => setfedudetails(e.target.value)} />
                                                    <label>{labelfedudetails}</label>
                                                </div>
                                            </div>
                                        </Col>


                                            </Row>
                                        </div>
                        </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                <div className="billbox paymentcollectbox stuCommonformbox">
                                            <div className="titlewithwhite">
                                                <p>Occupation</p>
                                            </div>

                                            <Row>
                                            <Col lg={3} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Occupation</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfoccupation ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={foccupation} onChange={(e) => setfoccupation(e.target.value)} />
                                                    <label>{labelfoccupation}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={3} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Details</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfoccudetails ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={foccudetails} onChange={(e) => setfoccudetails(e.target.value)} />
                                                    <label>{labelfoccudetails}</label>
                                                </div>
                                            </div>
                                        </Col>
                                            <Col lg={6} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Office Address</p>
                                                <div className="inputgap h35">
                                                    <input style={borderfofficeaddress ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={fofficeaddress} onChange={(e) => setfofficeaddress(e.target.value)} />
                                                    <label>{labelfofficeaddress}</label>
                                                </div>
                                            </div>
                                        </Col>


                                            </Row>
                                        </div>
                                </Col>
                            </Row>

                        </Tab.Pane>
                        <Tab.Pane eventKey="third"  className="px75">
                        <Row>

                    <Col lg={6} className="pr7">
                <div className="billbox paymentcollectbox stuCommonformbox">
                    <div className="titlewithwhite">
                        <p>Name</p>
                    </div>

                    <Row>
                    <Col lg={4} className='pr5'>
                    <div className="basicinputfield h35p">
                        <p>First</p>
                        <div className="inputgap h35">
                            <input style={bordermfirstname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mfirstname} onChange={(e) => setmfirstname(e.target.value)} />
                            <label>{labelmfirstname}</label>
                        </div>
                    </div>
                </Col>
                    <Col lg={4} className='pr5'>
                    <div className="basicinputfield h35p">
                        <p>Middle</p>
                        <div className="inputgap h35">
                            <input style={bordermmiddlename ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mmiddlename} onChange={(e) => setmmiddlename(e.target.value)} />
                            <label>{labelmmiddlename}</label>
                        </div>
                    </div>
                </Col>
                    <Col lg={4} className='pr5'>
                    <div className="basicinputfield h35p">
                        <p>Last</p>
                        <div className="inputgap h35">
                            <input style={bordermlastname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mlastname} onChange={(e) => setmlastname(e.target.value)} />
                            <label>{labelmlastname}</label>
                        </div>
                    </div>
                </Col>

                    </Row>
                </div>
                <div className="billbox paymentcollectbox stuCommonformbox">
                    <div className="titlewithwhite">
                        <p>Identity</p>
                    </div>

                    <Row>
                    <Col lg={6} className='pr5'>
                    <div className="basicinputfield h35p">
                        <p>National ID</p>
                        <div className="inputgap h35">
                            <input style={bordermnationalid ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mnationalid} onChange={(e) => setmnationalid(e.target.value)} />
                            <label>{labelmnationalid}</label>
                        </div>
                    </div>
                </Col>
                    <Col lg={6} className='pr5'>
                    <div className="basicinputfield h35p">
                        <p>Passport</p>
                        <div className="inputgap h35">
                            <input style={bordermpassport ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mpassport} onChange={(e) => setmpassport(e.target.value)} />
                            <label>{labelmpassport}</label>
                        </div>
                    </div>
                </Col>


                    </Row>
                </div>
                </Col>
                <Col lg={6} className="pr7">
                <div className="billbox paymentcollectbox stuCommonformbox">
                    <div className="titlewithwhite">
                        <p>Contact</p>
                    </div>

                    <Row>
                    <Col lg={6} className='pr5'>
                    <div className="basicinputfield h35p">
                        <p>Mobile</p>
                        <div className="inputgap h35">
                            <input style={bordermmobile ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mmobile} onChange={(e) => setmmobile(e.target.value)} />
                            <label>{labelmmobile}</label>
                        </div>
                    </div>
                </Col>
                    <Col lg={6} className='pr5'>
                    <div className="basicinputfield h35p">
                        <p>Phone</p>
                        <div className="inputgap h35">
                            <input style={bordermphone ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mphone} onChange={(e) => setmphone(e.target.value)} />
                            <label>{labelmphone}</label>
                        </div>
                    </div>
                </Col>


                    </Row>
                </div>
                <div className="billbox paymentcollectbox stuCommonformbox">
                    <div className="titlewithwhite">
                        <p>Education</p>
                    </div>

                    <Row>
                    <Col lg={6} className='pr5'>
                    <div className="basicinputfield h35p">
                        <p>Education</p>
                        <div className="inputgap h35">
                            <input style={bordermeducation ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={meducation} onChange={(e) => setmeducation(e.target.value)} />
                            <label>{labelmeducation}</label>
                        </div>
                    </div>
                    </Col>
                        <Col lg={6} className='pr5'>
                        <div className="basicinputfield h35p">
                            <p>Details</p>
                            <div className="inputgap h35">
                                <input style={bordermedudetails ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={medudetails} onChange={(e) => setmedudetails(e.target.value)} />
                                <label>{labelmedudetails}</label>
                            </div>
                        </div>
                    </Col>


                        </Row>
                    </div>
                            </Col>
                        </Row>
                        <Row>
                                    <Col lg={12}>
                                    <div className="billbox paymentcollectbox stuCommonformbox">
                                                <div className="titlewithwhite">
                                                    <p>Occupation</p>
                                                </div>

                                <Row>
                                <Col lg={3} className='pr5'>
                                <div className="basicinputfield h35p">
                                    <p>Occupation</p>
                                    <div className="inputgap h35">
                                        <input style={bordermoccupation ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={moccupation} onChange={(e) => setmoccupation(e.target.value)} />
                                        <label>{labelmoccupation}</label>
                                    </div>
                                </div>
                            </Col>
                                <Col lg={3} className='pr5'>
                                <div className="basicinputfield h35p">
                                    <p>Details</p>
                                    <div className="inputgap h35">
                                        <input style={bordermoccudetails ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={moccudetails} onChange={(e) => setmoccudetails(e.target.value)} />
                                        <label>{labelmoccudetails}</label>
                                    </div>
                                </div>
                            </Col>
                                <Col lg={6} className='pr5'>
                                <div className="basicinputfield h35p">
                                    <p>Office Address</p>
                                    <div className="inputgap h35">
                                        <input style={bordermofficeaddress ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={mofficeaddress} onChange={(e) => setmofficeaddress(e.target.value)} />
                                        <label>{labelmofficeaddress}</label>
                                    </div>
                                </div>
                            </Col>


                    </Row>
                </div>
        </Col>
                        </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="fourth" className="px75">
                        <Row>

                        <Col lg={6} className="pr7">
                        <div className="billbox paymentcollectbox stuCommonformbox">
                        <div className="titlewithwhite">
                            <p>Name</p>
                        </div>

                        <Row>
                        <Col lg={4} className='pr5'>
                        <div className="basicinputfield h35p">
                            <p>First</p>
                            <div className="inputgap h35">
                                <input style={borderlgfirstname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={lgfirstname} onChange={(e) => setlgfirstname(e.target.value)} />
                                <label>{labellgfirstname}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={4} className='pr5'>
                        <div className="basicinputfield h35p">
                            <p>Middle</p>
                            <div className="inputgap h35">
                                <input style={borderlgmiddlename ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={lgmiddlename} onChange={(e) => setlgmiddlename(e.target.value)} />
                                <label>{labellgmiddlename}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={4} className='pr5'>
                        <div className="basicinputfield h35p">
                            <p>Last</p>
                            <div className="inputgap h35">
                                <input style={borderlglastname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={lglastname} onChange={(e) => setlglastname(e.target.value)} />
                                <label>{labellglastname}</label>
                            </div>
                        </div>
                        </Col>

                        </Row>
                        </div>
                        <div className="billbox paymentcollectbox stuCommonformbox">
                        <div className="titlewithwhite">
                            <p>Identity</p>
                        </div>

                        <Row>
                        <Col lg={6} className='pr5'>
                        <div className="basicinputfield h35p">
                            <p>National ID</p>
                            <div className="inputgap h35">
                                <input style={borderlgnationalid ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={lgnationalid} onChange={(e) => setlgnationalid(e.target.value)} />
                                <label>{labellgnationalid}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={6} className='pr5'>
                        <div className="basicinputfield h35p">
                            <p>Passport</p>
                            <div className="inputgap h35">
                                <input style={borderlgpassport ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={lgpassport} onChange={(e) => setlgpassport(e.target.value)} />
                                <label>{labellgpassport}</label>
                            </div>
                        </div>
                        </Col>


                        </Row>
                        </div>
                        </Col>
                        <Col lg={6} className="pr7">
                        <div className="billbox paymentcollectbox stuCommonformbox">
                        <div className="titlewithwhite">
                            <p>Contact</p>
                        </div>

                        <Row>
                        <Col lg={6} className='pr5'>
                        <div className="basicinputfield h35p">
                            <p>Mobile</p>
                            <div className="inputgap h35">
                                <input style={borderlgmobile ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={lgmobile} onChange={(e) => setlgmobile(e.target.value)} />
                                <label>{labellgmobile}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={6} className='pr5'>
                        <div className="basicinputfield h35p">
                            <p>Relation</p>
                            <div className="inputgap h35">
                                <input style={borderlgrelation ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={lgrelation} onChange={(e) => setlgrelation(e.target.value)} />
                                <label>{labellgrelation}</label>
                            </div>
                        </div>
                        </Col>


                        </Row>
                        </div>

                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="fifth">
                            <Row>
                                <Col lg={6} className="m-auto">
                                <div className="billbox paymentcollectbox stuCommonformbox">
                                    <Row>
                                <Col lg={4} className='pr5'>
                                        <div className="basicinputfield h35p">
                                        <p>Blood Group</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper h35">
                                                <Dropdown2 err={borderbloodgroup} func={drpfuncbloodgroup} myplaceholder={bloodgroup}fontsize="12" fontfamily="'Poppins', sans-serif" options={bloodgroupresponse} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='pr5 pl5'>
                                        <div className="basicinputfield h35p">
                                        <p>Religion</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper h35">
                                                <Dropdown2 err={borderreligion} func={drpfuncreligion} myplaceholder={religion} fontsize="12" fontfamily="'Poppins', sans-serif" options={religionresponse} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className='pl5'>
                                        <div className="basicinputfield h35p">
                                        <p>Natinality</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper h35">
                                                <Dropdown2 err={bordernationality} func={drpfuncnationality} myplaceholder={nationality} fontsize="12" fontfamily="'Poppins', sans-serif" options={nationalityresponse} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} className='pr5'>
                                            <div className="basicinputfield h35p">
                                                <p>Passport</p>
                                                <div className="inputgap h35">
                                                    <input style={borderstupassport ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={stupassport} onChange={(e) => setstupassport(e.target.value)} />
                                                    <label>{labelstupassport}</label>
                                                </div>
                                            </div>
                                        </Col>
                                <Col lg={6} className='pl5'>
                                            <div className="basicinputfield h35p">
                                                <p>Birth Certificate No.</p>
                                                <div className="inputgap h35">
                                                    <input style={borderstubirthcertificate ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={stubirthcertificate} onChange={(e) => setstubirthcertificate(e.target.value)} />
                                                    <label>{labelstubirthcertificate}</label>
                                                </div>
                                            </div>
                                        </Col>
                                <Col lg={12}>
                                            <div className="basicinputfield h35p">
                                                <p>Emergency Medical Action</p>
                                                <div className="inputgap h35">
                                                    <input style={borderstuemergencymedical ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }}  type="text" value={stuemergencymedical} onChange={(e) => setstuemergencymedical(e.target.value)} />
                                                    <label>{labelstuemergencymedical}</label>
                                                </div>
                                            </div>
                                        </Col>
                                <Col lg={12}>
                                            <div className="basicinputfield h35p">
                                                <p>Medical History</p>
                                                <div className="inputgap h35">
                                                    <input style={borderstumedicalhistory ? { borderColor: "rgb(237, 28, 36)",height:"60px" } : { borderColor: "rgba(0,0,0,0.2)",height:"60px" }}  type="text" value={stumedicalhistory} onChange={(e) => setstumedicalhistory(e.target.value)} />
                                                    <label>{labelstumedicalhistory}</label>
                                                </div>
                                            </div>
                                        </Col>

                                    </Row>
                                </div>

                                </Col>
                            </Row>

                        </Tab.Pane>
                        <Tab.Pane eventKey="sixth">
                        <div className="billbox paymentcollectbox noborder">
                            <p className="applicationparagraph">Application for due payment of previous session before new enrollment. Select the status Accept if application is accepted and give the reason.</p>

                            <Row style={{marginTop:"30px"}}>
                                <Col lg={6} className="m-auto">
                                    <Row>
                                        <Col lg={5}>
                                        <div className="basicinputfield h35p">
                                        <p>Application Status</p>
                                        <div className="inputgap h35">
                                            <div className="dropdownwrapper h35">
                                                <Dropdown2 err={borderapplicationstatus} func={drpfuncapplicationstatus} myplaceholder={applicationstatus} fontsize="12" fontfamily="'Poppins', sans-serif" options={applicationstatusresponse} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="basicinputfield h35p">
                                <p>Effective From</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35">

                                        <DatePicker

                                            value={dateeffectivefrom}
                                            onChange={(newvaldob) => handleDateeffectivefrom(newvaldob)}
                                            renderInput={(params) => <TextField style={borderdateeffectivefrom==true?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}} {...params} inputProps={{
                                                ...params.inputProps,
                                                placeholder: ""
                                            }} error={false} />}
                                        />
                                        <label>{labeldateeffectivefrom}</label>


                                    </div>
                                </LocalizationProvider>
                            </div>
                                    <div className="basicinputfield h35p">
                                <p>Effective To</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35">

                                        <DatePicker

                                            value={dateeffectiveto}
                                            onChange={(newvaldob) => handleDateeffectiveto(newvaldob)}
                                            renderInput={(params) => <TextField style={borderdateeffectiveto==true?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}} {...params} inputProps={{
                                                ...params.inputProps,
                                                placeholder: ""
                                            }} error={false} />}
                                        />
                                        <label>{labeldateeffectiveto}</label>


                                    </div>
                                </LocalizationProvider>
                            </div>
                                        </Col>
                                        <Col lg={6} className='pl5'>

                                        <div className="basicinputfield h35p">
                                        <p>Reason</p>
                                        <div className="inputgap h35">
                                            <input style={borderduereason ? { borderColor: "rgb(237, 28, 36)",height:"171px" } : { borderColor: "rgba(0,0,0,0.2)",height:"171px" }} type="text" value={duereason} onChange={(e) => setduereason(e.target.value)} />
                                            <label>{labelduereason}</label>
                                        </div>
                                    </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="seventh">
                            <Row>
                                <Col lg={8} className="m-auto">
                                    <div className="statustable">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>SL</th>
                                                    <th>Student Status</th>
                                                    <th>Status Change Reason</th>
                                                    <th>Status Change Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                    {
                                                        statusTableApi.data.map((item,key)=>{
                                                            return(
                                                                <tr>
                                                                <td></td>
                                                </tr>
                                                            )
                                                        })
                                                    }
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="eighth">
                        <Row>
                                <Col lg={11} className="m-auto">
                                    <div className="statustable paymenthistorytable">
                                        <table>
                                            <thead>
                                                <tr>
                                               {
                                                paymenthistorystuApi.heading.map((item,key)=>{
                                                    return(
                                                            <th>{item.head}</th>
                                                            )
                                                        })
                                                    }
                                                    </tr>
                                            </thead>
                                            <tbody>
                                                    {
                                                        stuPrvsBillresponse?stuPrvsBillresponse.map((item,key)=>{
                                                            return(
                                                            <tr>
                                                                <td>{item.name}</td>
                                                                <td>{item.billno}</td>
                                                                <td>{item.className}</td>
                                                                <td>{item.period}</td>
                                                                <td>{item.date}</td>
                                                                <td>{item.rcvtype}</td>
                                                                <td>{item.amount}</td>
                                                                <td>{item.remarks}</td>
                                                             </tr>
                                                            )
                                                        }):""
                                                    }
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="ninth">
                            <Row>
                                <Col lg={10} className="m-auto">
                                    <Row>
                                        <Col lg={6}>
                                        <div style={{height:"210px"}} className="billbox paymentcollectbox stuCommonformbox">
                                        <div className="titlewithwhite">
                                            <p>Allow Mark</p>
                                        </div>
                                        <div className="marktext">
                                            <p>This setting only allows for inactive students of current session. If a student is inactive but you still want to allow the teacher to submit marks then use this setting.Set true from the dropdown list for giving permission to the teacher.</p>
                                        </div>

                                        <Row className="my-4 permissionmain">
                                            <Col lg={8} className='pr5'>
                                                <div className="dropdownwrapper">
                                                <Dropdown2 func={drpfunctionmarkallow} myplaceholder={markallow} fontsize="12" fontfamily="'Poppins', sans-serif" options={allowmarkresponse} />
                                            </div>
                                            </Col>
                                            <Col lg={4} className="pl5">
                                                <div className="mybuttonpermission">
                                                    <button onClick={handleAllowMarkSave}>Save</button>
                                                </div>
                                            </Col>
                                            </Row>
                                        </div>
                                        </Col>
                                        <Col lg={6}>
                                        <div style={{height:"210px"}} className="billbox paymentcollectbox stuCommonformbox">
                                        <div className="titlewithwhite">
                                            <p>Set for Second Semester Result Only</p>
                                        </div>
                                        <div className="marktext">
                                            <p>This setting will set the student only for the second-semester result. The first-semester result won’t generate for the student. Select true from the dropdown and click save to save the data.</p>
                                        </div>

                                        <Row className="permissionmain permissionmainsecond" >
                                            <Col lg={8} className='pr5'>
                                                <div className="dropdownwrapper">
                                                <Dropdown2 func={drpfunctionsecondsemesterallow} myplaceholder={secondsemesterallow} fontsize="12" fontfamily="'Poppins', sans-serif" options={allowSecondSemesterResultresponse} />
                                            </div>
                                            </Col>
                                            <Col lg={4} className="pl5">
                                                <div className="mybuttonpermission">
                                                    <button onClick={handlePermissionSave}>Save</button>
                                                </div>
                                            </Col>
                                            </Row>
                                        </div>
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>
                        </Tab.Pane>
                    </Tab.Content>
                    </Col>
                </Row>
                </Tab.Container>
                    </div>
                </div>
        </div>
    </div>
</div>
    </>
  )
}

export default StudentEntryMainComp